


"undefined" == typeof freegifts_product_json && (window.freegifts_product_json = function(e) {
    if (e) {
        for (var i = 0; i < e.options.length; i++)
            if (option = e.options[i], option.values)
                for (var r = 0; r < option.values.length; r++)(option.values[r].endsWith("(Freegifts)") || option.values[r].endsWith("% off)")) && (option.values.splice(r, 1), r--);
        for (var a = function(e) {
                for (var i in e)
                    if (e.hasOwnProperty(i)) return !1;
                return !0
            }, p = e.price, t = e.price_max, o = e.price_min, n = e.compare_at_price, _ = e.compare_at_price_max, c = e.compare_at_price_min, i = 0; i < e.variants.length; i++) {
            var r = e.variants[i],
                s = r.option3 ? r.option3 : r.option2 ? r.option2 : r.option1;
            "undefined" != typeof SECOMAPP && "undefined" != typeof SECOMAPP.gifts_list_avai && !a(SECOMAPP.gifts_list_avai) && "undefined" != typeof SECOMAPP.gifts_list_avai[r.id] || s.endsWith("(Freegifts)") || s.endsWith("% off)") ? (e.variants.splice(i, 1), i -= 1) : (t >= r.price && (t = r.price, p = r.price), o <= r.price && (o = r.price), r.compare_at_price && (_ >= r.compare_at_price && (_ = r.compare_at_price, n = r.compare_at_price), c <= r.compare_at_price && (c = r.compare_at_price)), 1 == r.available && (e.available = !0))
        }
        e.price = p, e.price_max = o, e.price_min = t, e.compare_at_price = n, e.compare_at_price_max = c, e.compare_at_price_min = _, e.price_varies = o > t ? !0 : !1, e.compare_at_price_varies = c > _ ? !0 : !1
    }
    return e
});

if ((typeof Shopify) === 'undefined') { Shopify = {}; }
// Get from cart.js returns the cart in JSON
Shopify.getCart = function(callback) {
    jQuery.getJSON('/cart.js', function(cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else if (Array.isArray(callback)) {
            for (i = 0; i < callback.length; i++) {
                if (typeof callback[i] === 'function') {
                    callback[i](cart);
                }
            }
        } else if (typeof Shopify.onCartUpdate === 'function') {
            Shopify.onCartUpdate(cart);
        }
    });
};

window.slate = window.slate || {};
window.theme = window.theme || {};

generateLoader = function(extraClasses) {
    if (typeof extraClasses === typeof undefined) extraClasses = '';
    var x = '';
    x += '<span class="loader ' + extraClasses + '">';
    x += '<svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">';
    x += '<g fill="none" fill-rule="evenodd">';
    x += '<g transform="translate(1 1)" stroke-width="2">';
    x += '<circle stroke-opacity=".5" cx="18" cy="18" r="18"/>';
    x += '<path id="test" d="M36 18c0-9.94-8.06-18-18-18">';
    x += '</path>';
    x += '</g>';
    x += '</g>';
    x += '</svg>';
    x += '</span>';
    return x;
}

window.cart = JSON.parse($('[data-cart-json]').text());
$(window).on('cart-changed', function(e, d) {
    window.cart = d;
      if(window.location.href.includes('/cart')){
        location.reload();
    }
}.bind(this));


// [name] is the name of the event "click", "mouseover", ..
// same as you'd pass it to bind()
// [fn] is the handler function
$.fn.bindFirst = function(name, fn) {
    // bind as you normally would
    // don't want to miss out on any jQuery magic
    this.on(name, fn);

    // Thanks to a comment by @Martin, adding support for
    // namespaced events too.
    this.each(function() {
        var handlers = $._data(this, 'events')[name.split('.')[0]];
        // take out the handler we just inserted from the end
        var handler = handlers.pop();
        // move it at the beginning
        handlers.splice(0, 0, handler);
    });
};

var isChrome = /chrom(e|ium)/.test(navigator.userAgent.toLowerCase());
if (isChrome) {
    $(document).ready(function() {
        $(document.body).addClass('is-chrome');
    });
}

/*=============== Polyfill ===============*/
Object.assign = Object.assign || function(t, j) {
    if (!j) return t;
    for (var key in j) {
        t[key] = j[key]
    }
    return t;
}

function searchToObject() {
    var pairs = window.location.search.substring(1).split("&"),
        obj = {},
        pair,
        i;

    for (i in pairs) {
        if (pairs[i] === "") continue;
        pair = pairs[i].split("=");
        obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return obj;
};

window.query = searchToObject();
Array.prototype.contains = Array.prototype.contains || function(obj) {
    return this.indexOf(obj) !== -1;
}
String.prototype.includes = String.prototype.includes || function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
        start = 0;
    }

    if (start + search.length > this.length) {
        return false;
    } else {
        return this.indexOf(search, start) !== -1;
    }
}

//Fixes a bug with Android not having the :checked pseudoclass, also helps us a bit with styling our checkboxes...
$(document).on('change', 'input[type="checkbox"]', function(e) {
    var self = $(this);
    var parent = self.parent();
    var isChecked = self.prop('checked');

    if (parent.hasClass('checkbox')) {
        if (isChecked) {
            parent.addClass('checked');
        } else {
            parent.removeClass('checked');
        }
    }

    if (isChecked) {
        self.addClass('checked');
    } else {
        self.removeClass('checked');
    }
})
Date.prototype.isValidDate || (Date.prototype.isValidDate = function() {
    if (Object.prototype.toString.call(this) === "[object Date]") {
        if (isNaN(this.getTime())) {
            return false;
        } else {
            return true;
        }
    }
    return false;
});
window.getDevicePixelRatio = function() {
    var ratio = 1;
    if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
        ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
    } else if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
    }
    return ratio;
};


/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function($element) {
        var focusClass = 'js-focus-hidden';

        $element.first()
            .attr('tabIndex', '-1')
            .focus()
            .addClass(focusClass)
            .one('blur', callback);

        function callback() {
            $element.first()
                .removeClass(focusClass)
                .removeAttr('tabindex');
        }
    },

    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function() {
        var hash = window.location.hash;

        // is there a hash in the url? is it an element on the page?
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },

    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function() {
        $('a[href*=#]').on('click', function(evt) {
            this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this));
    },

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options) {
        var eventName = options.namespace ?
            'focusin.' + options.namespace :
            'focusin';

        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }

        options.$container.attr('tabindex', '-1');
        options.$elementToFocus.focus();

        $(document).on(eventName, function(evt) {
            if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
                options.$container.focus();
            }
        });
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
        var eventName = options.namespace ?
            'focusin.' + options.namespace :
            'focusin';

        if (options.$container && options.$container.length) {
            options.$container.removeAttr('tabindex');
        }

        $(document).off(eventName);
    }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

    /**
     * Browser cookies are required to use the cart. This function checks if
     * cookies are enabled in the browser.
     */
    cookiesEnabled: function() {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
        }
        return cookieEnabled;
    }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function(array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
    },

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function(array, key, value) {
        var i = array.length;
        while (i--) {
            if (array[i][key] === value) {
                array.splice(i, 1);
                break;
            }
        }

        return array;
    },

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function(array) {
        var index = -1;
        var length = array == null ? 0 : array.length;
        var resIndex = 0;
        var result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    },

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value
    }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
    /**
     * Wrap tables in a container div to make them scrollable when needed
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
     * @param {string} options.tableWrapperClass - table wrapper class name
     */
    wrapTable: function(options) {
        var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

        options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
    },

    /**
     * Wrap iframes in a container div to make them responsive
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
     * @param {string} options.iframeWrapperClass - class name used on the wrapping div
     */
    wrapIframe: function(options) {
        var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

        options.$iframes.each(function() {
            // Add wrapper to make video responsive
            $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

            // Re-set the src attribute on each iframe after page load
            // for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791
            // Need to specifically target video and admin bar
            this.src = this.src;
        });
    }
};

slate.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
        .on('shopify:section:load', this._onSectionLoad.bind(this))
        .on('shopify:section:unload', this._onSectionUnload.bind(this))
        .on('shopify:section:select', this._onSelect.bind(this))
        .on('shopify:section:deselect', this._onDeselect.bind(this))
        .on('shopify:section:reorder', this._onReorder.bind(this))
        .on('shopify:block:select', this._onBlockSelect.bind(this))
        .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function(container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
            return;
        }

        var instance = $.extend(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function(evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (!instance) {
            return;
        }

        if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
        }

        this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
    },

    _onSelect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onSelect === 'function') {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onDeselect === 'function') {
            instance.onDeselect(evt);
        }
    },

    _onReorder: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onReorder === 'function') {
            instance.onReorder(evt);
        }
    },

    _onBlockSelect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === 'function') {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === 'function') {
            instance.onBlockDeselect(evt);
        }
    },

    register: function(type, constructor) {
        this.constructors[type] = constructor;

        $('[data-section-type=' + type + ']').each(function(index, container) {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
    var moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || moneyFormat);

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = slate.utils.defaultTo(precision, 2);
            thousands = slate.utils.defaultTo(thousands, ',');
            decimal = slate.utils.defaultTo(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_space_separator':
                value = formatWithDelimiters(cents, 2, ' ', '.');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ',', '.');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney
    };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
        if (typeof images === 'string') {
            images = [images];
        }

        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
        new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

        if (match) {
            return match[1];
        } else {
            return null;
        }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === 'master') {
            return this.removeProtocol(src);
        }
        if (src) {
            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        }

        if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + '_' + size + suffix);
        } else {
            return null;
        }
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
    }

    return {
        preload: preload,
        loadImage: loadImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();

        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {

        /**
         * Get the currently selected options from add-to-cart form. Works with all
         * form input elements.
         *
         * @return {array} options - Values of currently selected variants
         */
        _getCurrentOptions: function() {
            var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
                var $element = $(element);
                var type = $element.attr('type');
                var currentOption = {};

                if (type === 'radio' || type === 'checkbox') {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');

                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');

                    return currentOption;
                }
            });

            // remove any unchecked input values if using radio buttons or checkboxes
            currentOptions = slate.utils.compact(currentOptions);

            return currentOptions;
        },

        /**
         * Find variant based on selected values.
         *
         * @param  {array} selectedValues - Values of variant inputs
         * @return {object || undefined} found - Variant object from product.variants
         */
        _getVariantFromOptions: function() {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = false;

            variants.forEach(function(variant) {
                var satisfied = true;

                selectedValues.forEach(function(option) {
                    if (satisfied) {
                        satisfied = (option.value === variant[option.index]);
                    }
                });

                if (satisfied) {
                    found = variant;
                }
            });

            return found || null;
        },

        /**
         * Event handler for when a variant input changes.
         */
        _onSelectChange: function() {
            var variant = this._getVariantFromOptions();

            this.$container.trigger({
                type: 'variantChange',
                variant: variant
            });

            if (!variant) {
                return;
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this.currentVariant = variant;

            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
        },

        /**
         * Trigger event when variant image changes
         *
         * @param  {object} variant - Currently selected variant
         * @return {event}  variantImageChange
         */
        _updateImages: function(variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};

            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }

            this.$container.trigger({
                type: 'variantImageChange',
                variant: variant
            });
        },

        /**
         * Trigger event when variant price changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantPriceChange
         */
        _updatePrice: function(variant) {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }

            this.$container.trigger({
                type: 'variantPriceChange',
                variant: variant
            });
        },

        /**
         * Update history state for product deeplinking
         *
         * @param {object} variant - Currently selected variant
         */
        _updateHistoryState: function(variant) {
            if (!history.replaceState || !variant) {
                return;
            }

            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({ path: newurl }, '', newurl);
        },

        /**
         * Update hidden master select of variant change
         *
         * @param {object} variant - Currently selected variant
         */
        _updateMasterSelect: function(variant) {
            $(this.originalSelectorId, this.$container)[0].value = variant.id;
        }
    });

    return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {

    var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]:first-of-type',
        productThumbs: '.product-thumbnails',
        singleOptionSelector: '[data-single-option-selector]',
    };

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }

        var sectionId = this.$container.attr('data-section-id');
        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

        this.quantity = new ProductQuantitySelector(this.$container.find('.product-quantity-selector'));

        var options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: freegifts_product_json(this.productSingleObject)
        };

        this.settings = {};
        this.namespace = '.product';
        this.variants = new slate.Variants(options);
        this.thumbsContainer = this.$container.find(selectors.productThumbs);

        this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
        this.$container.on('variantChange' + this.namespace, this.onVariantUpdate.bind(this));
        this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

        this.thumbnails = new ProductPageThumbnails(this.thumbsContainer);


        // $('.slider-single').slick({
        //   slidesToShow: 1,
        //   slidesToScroll: 1,
        //   arrows: true,
        //   fade: false,
        //   //adaptiveHeight: true,
        //   //infinite: false,
        //   useTransform: true,
        //   speed: 400,
        //   cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
        // });
        //
        // $('.slider-nav')
        //   .on('init', function(event, slick) {
        //     $('.slider-nav .slick-slide.slick-current').addClass('is-active');
        //   })
        //   .slick({
        //     slidesToShow: 5,
        //     slidesToScroll: 5,
        //     dots: false,
        //     focusOnSelect: false,
        //     infinite: false,
        //     responsive: [{
        //       breakpoint: 1024,
        //       settings: {
        //         slidesToShow: 5,
        //         slidesToScroll: 5,
        //       }
        //     }, {
        //       breakpoint: 640,
        //       settings: {
        //         slidesToShow: 4,
        //         slidesToScroll: 4,
        //       }
        //     }, {
        //       breakpoint: 420,
        //       settings: {
        //         slidesToShow: 3,
        //         slidesToScroll: 3,
        //       }
        //     }]
        //   });
        //
        // $('.slider-single').on('afterChange', function(event, slick, currentSlide) {
        //   $('.slider-nav').slick('slickGoTo', currentSlide);
        //   var currrentNavSlideElem = '.slider-nav .slick-slide[data-slick-index="' + currentSlide + '"]';
        //   $('.slider-nav .slick-slide.is-active').removeClass('is-active');
        //   $(currrentNavSlideElem).addClass('is-active');
        // });
        //
        // $('.slider-nav').on('click', '.slick-slide', function(event) {
        //   event.preventDefault();
        //   var goToSingleSlide = $(this).data('slick-index');
        //
        //   $('.slider-single').slick('slickGoTo', goToSingleSlide);
        // });


        this.onVariantUpdate(this.variants.currentVariant);

        this.$container.on('click touchend', selectors.addToCart, this.addToCart.bind(this));

        this.loader = this.$container.find('.product-loader');

        this.reviews = this.$container.find('.product-reviews');
        this.reviews.on('click', '[data-toggle-reviews]', this.toggleReviews.bind(this));

        this.yotpoUnderPrice = this.$container.find('.yotpo-below-price');
        var anchors = this.yotpoUnderPrice.add('.text-m');
        anchors.bindFirst('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            this.expandReviews();
        }.bind(this));
    }

    Product.prototype = $.extend({}, Product.prototype, {
        toggleReviews: function(evt) {
            this.reviews.find('[data-reviews-section]').toggleClass('is-visible');
        },

        expandReviews: function(e) {
            this.reviews.find('[data-reviews-section]').addClass('is-visible');
        },

        addToCart: function(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            this.loader.addClass('visible');

            var existingQty = 0;
            var id = this.$container.find('[name="id"]').val()
            if (window.cart && window.cart.items) {
                for (var i = 0; i < window.cart.items.length; i++) {
                    var c = window.cart.items[i];
                    if (!c) continue;
                    if (!c.quantity) continue;
                    if (c.id != id) continue;
                    existingQty = c.quantity;
                    break;
                }
            }
            var o = {};
            o[id] = existingQty + this.quantity.getAmount();
            $.ajax({
                url: '/cart/update.js',
                dataType: "json",
                method: "POST",
                data: {
                    updates: o
                },
                success: this.addedToCart.bind(this),
                error: function(e, a) {
                    console.log(e);
                    console.log(a);
                    window.location.reload();
                }
            });
        },

        addedToCart: function(data) {
            var _this = this;
            Shopify.getCart(function(cart) {
                $(window).trigger('cart-changed', cart);
                window.ajaxCart.open();
                _this.loader.removeClass('visible');
            }, data);
        },

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function(evt) {
            var variant = evt.variant;

            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass('hide');
                $(selectors.originalSelectorId).val(variant.id);
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $('.product-information-container .product-quantity-selector').addClass('product-quantity-selector-notify_me');
                $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
                $(selectors.priceWrapper, this.$container).addClass('hide');
                return;
            }

            if (variant.available && variant.price > 0) {
                $(selectors.addToCart, this.$container).prop('disabled', false);
                $('.product-information-container .product-quantity-selector').removeClass('product-quantity-selector-notify_me');
                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $('.product-information-container .product-quantity-selector').addClass('product-quantity-selector-notify_me');
                $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
            }
        },

        //Updates the product quantity selector to be valid
        updateProductQuantityMinMax: function(variant) {
            if (typeof variant === typeof undefined || !variant) {
                this.quantity.setMax(0);
                return;
            }

            if (variant.available && variant.inventory_quantity <= 0) {
                this.quantity.setMax(-1);
            } else {
                this.quantity.setMax(variant.inventory_quantity);
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function(evt) {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

            $(selectors.productPrice, this.$container)
                .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                $compareEls.removeClass('hide');
            } else {
                $comparePrice.html('');
                $compareEls.addClass('hide');
            }
        },

        /**
         * Updates certain DOM based elements on Variant update, and fired on page load as well.
         */
        onVariantUpdate: function(variant) {
            if (variant.variant) variant = variant.variant;

            this.updateProductQuantityMinMax(variant);
            this.updateVariantImage(variant);
        },

        updateVariantImage: function(variant) {
            if (variant.featured_image) {
                this.thumbnails.setSlideByID(variant.featured_image.id);
            }
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function() {
            this.$container.off(this.namespace);
        }
    });

    return Product;
})();


/*================= Modules =================*/
//Menu Prototype
function Menu(container) {
    this.container = container;
    this.body = this.container.find('.menu-body');
    this.background = this.container.find('.menu-background');

    //Event Handlers
    this.container.on('click', '.menu-background', this.close.bind(this));
    this.container.on('click touchend', '[data-action="close-menu"]', this.close.bind(this));
}

Menu.prototype = {
    isOpen: function() { return this.container.hasClass('visible'); },
    isHiding: function() { return this.container.hasClass('hiding'); },

    open: function(e) {
        if (typeof e !== typeof undefined) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (this.isOpen()) return;

        this.stopHideTask();
        this.container.addClass('visible');
        this.container.removeClass('hiding');
        this.body.addClass('visible');
        $(document.body).addClass('menu-open');
        $("html").addClass('menu-open');
        this.onMenuOpen(this);
    },

    close: function(e) {
        if (typeof e !== typeof undefined) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (!this.isOpen()) return;

        //Menu close future
        $(document.body).removeClass("menu-open");
        $("html").removeClass('menu-open');
        this.container.addClass("hiding");
        this.container.removeClass("visible");
        this.body.removeClass('visible');
        this.onMenuClose();
        this.stopHideTask();

        this.stopTask = setTimeout(function() {
            this.container.removeClass("hiding");
            this.stopHideTask();
        }.bind(this), 200);
    },

    onMenuOpen: function(self) {},
    onMenuClose: function(self) {},

    toggleOpen: function() {
        if (this.isOpen()) {
            this.close();
        } else {
            this.open();
        }
    },

    stopHideTask: function() {
        if (this.stopTask) {
            clearTimeout(this.stopTask);
            this.stopTask = null;
        }
    }
};

//Statics
window.menus = window.menus || [];
window.findMenu = window.findMenu || function(selector) {
    for (var i = 0; i < window.menus.length; i++) {
        if (!window.menus[i].container.is(selector)) continue;
        return window.menus[i];
    }
    return null;
}

$(document).ready(function() {
    $('.menu').each(function() {
        var m = new Menu($(this));
        window.menus.push(m);
    });
});

$(document).on('click touchend', '[data-action="open-menu"]', function(e) {
    var self = $(this);
    if (!self.data('target')) return;

    e.preventDefault();
    e.stopPropagation();

    var target = self.data('target');
    var menu = window.findMenu(target);
    if (menu == null) return;
    menu.open();
});

function AjaxForm(form) {
    this.form = form;
}

AjaxForm.prototype.submit = function() {
    var url = this.form.prop("action");
    var method = this.form.prop.method || "POST";
    var data = {};

    this.form.each(function(d) {
        var e = $(this);
        data[e.prop("name")] = e.val();
    });


    this.ajax = $.ajax({
        url: url,
        method: method,
        data: data,
        success: this.success.bind(this),
        error: this.error.bind(this)
    })
}
AjaxForm.prototype.success = function(data) {
    this.data = data;
    try {
        this.onSuccess(data);
    } catch (e) {
        console.error(e);
    }
}
AjaxForm.prototype.error = function(e) {
    try {
        this.onError(e);
    } catch (e) {
        console.error(e);
    }
}

function AjaxCollection(handle, container) {
    this.handle = handle;
    this.productsByHandle = {}
    this.productsByID = {};
    this.products = [];
    this.container = container;

    this.productHandlers = [];
    this.collectionHandlers = [];
    this.tagHandlers = [];
    this.filterListeners = [];

    this.processingRequests = [];

    this.nextRequestID = 0;

    //Default Filter
    this.f = {
        sort: AjaxCollection.constants.sort['Page']
    };

    //Is there a URL based tag filter setup?
    var path = window.location.pathname; //Current path;
    var pathParts = path.split("/"); //Seperate the parts into slashes

    //Since index 0  may be "" then it will have length 3 if index 0 != "" and 4 i
    if (
        (pathParts.length == 3 && pathParts[0].length != 0) ||
        (pathParts.length == 4 && pathParts[0].length == 0)
    ) {
        var tagPathOffset = pathParts.length == 3 ? 0 : 1;
        //Tag filter
        var tagURL = pathParts[2 + tagPathOffset];
        //Remove the query
        var tag = tagURL.split("?")[0];
        if (tag.length) {
            this.f.tags = this.f.tags || [];
            this.f.tags.push(tag);
            this.f.tagLocked = true;
        }
    }

    //Are some producs existing already?
    this.existingData = container.find('[data-collection-json]');
    if (this.existingData.length) {
        var raw = this.existingData.html();
        try {
            raw = JSON.parse(raw);
        } catch (e) {
            console.error(e);
            return;
        }
        this.parseJSON(raw, this.page || 1);
    }
}

AjaxCollection.constants = {
    urlPrefix: '/collections/',
    callsAtATime: 1,

    //Setup your sorting functions here
    sort: {
        'Page': {
            name: 'Default',
            method: function(a, b) { return a.order - b.order; }
        },
        'A-Z': {
            name: "A - z",
            method: function(a, b) { return a.data.title.localeCompare(b.data.title); }
        },
        'Z-A': {
            name: "Z - a",
            method: function(a, b) { return b.data.title.localeCompare(a.data.title); }
        },
        'Price-Low': {
            name: 'Price, Low to High',
            method: function(a, b) { return a.data.price - b.data.price; }
        },
        'Price-High': {
            name: 'Price, High to Low',
            method: function(a, b) { return b.data.price - a.data.price; }
        }
    }
};

AjaxCollection.prototype = {
    getBaseURL: function() {
        return AjaxCollection.constants.urlPrefix + this.handle + (this.f.tagLocked ? "/" + this.f.tags[0] : "");
    },

    hasMoreProducts: function() {
        var more = typeof this.total_products === typeof undefined || this.products.length < this.total_products;
        return more;
    },

    fetch: function(page) {
        if (page <= 0) throw "Page must be 1 or higher";
        if (!this.hasMoreProducts()) return;
        //console.log('Fetching page ' + page);

        var params = {
            view: 'json',
            page: page,
            perPage: 16
        };

        params = this.addCustomParams(params);

        var requestParams = {

        }

        var request = $.ajax({
            url: this.getBaseURL(),
            data: params,
            method: 'GET',
            error: this.onError.bind(requestParams)
        });
        requestParams.page = page;
        requestParams.id = this.nextRequestID++;
        requestParams.self = this;
        requestParams.request = request;


        request.done(this.onData.bind(requestParams));
        this.processingRequests.push(request);
        return request;

    },

    onData: function(data) {
        /*
         * Reference issues? MAKE SURE YOU'RE REFERENCING SELF, NOT THIS
         */
        var self = this.self;

        self.processingRequests.splice(self.processingRequests.indexOf(this.request), 1);
        var j;
        try {
            j = JSON.parse(data);
            if (!j.collection || typeof j.total_products === typeof undefined || typeof j.products === typeof undefined) throw "Invalid JSON";
        } catch (e) {
            return self.onError(e);
        }

        self.parseJSON(j, this.page, this);
    },


    parseJSON: function(j, page, requestParams) {
        this.id = j.collection.id;
        requestParams.page = page;
        if (j.collection.body_html) this.body_html = j.collection.body_html;
        if (j.collection.title) this.title = j.collection.title;

        if (!this.all_tags && j.collection.all_tags) {
            this.all_tags = j.collection.all_tags;
            this.tags = this.tags || [];
            for (var i = 0; i < this.all_tags.length; i++) {
                var tag = this.all_tags[i];
                if (!tag) continue;
                if (this.tags.contains(tag)) continue;
                this.tags.push(tag);
            }

            var tag_filters = {};
            for (var i = 0; i < this.tags.length; i++) {
                var t = this.tags[i];
                if (!t.includes("_")) continue;
                var split = t.split("_");
                var group = split[0];
                var val = split[1];
                tag_filters[group] = tag_filters[group] || [];
                if (tag_filters[group].contains(val)) continue;
                tag_filters[group].push(val);
            }
            this.tag_filters = tag_filters;

            this.onTagsUpdated();
        }

        this.total_products = j.total_products;

        for (var i = 0; i < j.products.length; i++) {
            var product = j.products[i];
            if (!product || !product.data || !product.data.handle) continue;
            var handle = product.data.handle;
            if (this.productsByHandle[handle]) continue;
            this.productsByHandle[handle] = product;
            this.productsByID[product.data.id] = product;
            this.products.push(product);
            product.order = page * 10000 + i; //TODO: Make this a bit better
        }

        this.onRequestComplete(requestParams);
    },


    onRequestComplete: function(request) {

        this.redraw(true);

        if (!this.hasFinished) {
            for (var i = 0; i < this.productHandlers.length; i++) {
                this.productHandlers[i].onProductsUpdated(this.products, this);
            }
            this.onProductsFetched();
        }

        if (!this.hasMoreProducts()) {
            console.log("No More Products");
            if (!this.hasFinished) {
                this.hasFinished = true;
                this.onCollectionFetched();
            }
            this.doRedraw(true);
            return;
        }
        var o = {
            self: this,
            request: request
        };
        //setTimeout(function() {
        //this.self.fetch(this.request.page + AjaxCollection.constants.callsAtATime);
        //}.bind(o), 500);

        this.fetch(request.page + AjaxCollection.constants.callsAtATime);
    },

    onError: function(error, a, b) {
        //TODO: Handle errors properly
        //console.error("Error!");
        setTimeout(function() {
            this.self.fetch(this.page);
        }.bind(this), 10000);
        console.error(error);
        //window.location.reload();
        if (a) console.error(a);
        if (b) console.error(b);
    },

    redraw: function(afterFetch) {
        if (typeof this.renderTimeout !== typeof undefined) return;
        this.renderTimeout = setTimeout(function() {
            this.doRedraw(afterFetch);
        }.bind(this), 500);
    },

    doRedraw: function(afterFetch) {
        delete this.renderTimeout;

        products_to_print = [];
        for (var i = 0; i < this.products.length; i++) {
            var p = this.products[i];

            var show = false;

            //Filter
            if (this.f.brands) {
                if (typeof p.data.vendor !== typeof undefined && p.data.vendor && this.f.brands[p.data.vendor]) {
                    show = true
                }
            }

            if ((show || !this.f.brands) && this.f.tags && this.f.tags.length) {
                var hasTag = false;

                if (typeof p.data.tags !== typeof undefined && p.data.tags.length) {
                    for (var t = 0; t < this.f.tags.length; t++) {
                        var productTags = p.data.tags;
                        var fixedFilterTag = this.f.tags[t].replace(/ /g, "-");
                        for (var x = 0; x < productTags.length; x++) {
                            var fixedProductTag = productTags[x].replace(/ /g, "-");
                            //console.log("Comparing " + fixedProductTag + " with " + fixedFilterTag);
                            if (fixedProductTag != fixedFilterTag) continue;
                            show = true;
                            hasTag = true;
                            break;
                        }
                        if (!hasTag) continue;
                        break;
                    }
                }

                if (!hasTag) show = false;
            }

            if (!this.f.brands && (!this.f.tags || !this.f.tags.length)) {
                show = true;
            }

            if (show && this.f.price) {
                if (p.data.price >= this.f.price.min && (typeof this.f.price.max === 'string' || p.data.price <= this.f.price.max)) {
                    show = true;
                } else {
                    show = false;
                }
            }


            if (show) {
                products_to_print.push(p);
            }

        }


        //Sort
        if (this.f.sort) { products_to_print.sort(this.f.sort.method); }

        //Paginate
        this.unpaginatedProductCount = products_to_print.length;
        products_to_print = this.paginate(products_to_print);


        //Only reprint products when needed
        var reloadProducts = true;

        if (afterFetch) {

            if (this.printedProducts) {

                if (this.printedProducts.length == products_to_print.length) {

                    for (var i = 0; i < products_to_print.length; i++) {

                        if (products_to_print[i].data.id !== this.printedProducts[i].data.id) {
                            break;
                        } else if (i == products_to_print.length - 1) {
                            reloadProducts = false;
                        }

                    }

                }

            } else {
                reloadProducts = false;
            }

        }



        if (reloadProducts) {

            console.log("Reprinting products");

            //Clear existing products that aren't in the new group
            if (typeof this.printedProducts !== typeof undefined) {
                for (var i = 0; i < this.printedProducts.length; i++) {
                    var p = this.printedProducts[i];
                    //if(products_to_print.contains(p)) continue;

                    var printed = this.getPrintedProduct(p);
                    if (typeof printed === typeof undefined || !printed) continue;
                    printed.remove();
                }
            }

            var previousProductElement;
            for (var i = 0; i < products_to_print.length; i++) {
                //Is this product already printed?
                var p = products_to_print[i];
                var e = null;
                if (
                    typeof this.printedProducts !== typeof undefined && this.printedProducts.contains(p)
                ) {
                    e = this.getPrintedProduct(p);
                }

                if (typeof e === typeof undefined || !e) {
                    var x = this.printProduct(products_to_print[i]);
                    if (
                        typeof previousProductElement === typeof undefined ||
                        previousProductElement == null ||
                        !previousProductElement.length
                    ) {
                        this.container.html(x);
                        e = $(this.container.children()[0]);
                    } else {
                        e = $(x).insertAfter(previousProductElement);
                    }
                }
                if (typeof e !== typeof undefined) previousProductElement = e;
            }
            if (!products_to_print.length) {
                this.container.html('<div class="collection-no-results">' + window.theme.strings.noResults + '</div>');
            }


            updateFreeGiftBadge();

        } //endif
        this.printedProducts = products_to_print;

    },



    getPrintedProduct: function(product) {
        var el = this.container.find('[data-product-thumbnail="' + product.data.handle + '"]');
        if (!el.length) return null; //Rather than returning an empty jQuery object, return null.
        return el;
    },

    paginate: function(list_of_all_products) {
        return list_of_all_products; //No pagination
    },

    printProduct: function(product) {
        var x = decodeURIComponent(product.print);
        return x;
    },

    filter: function(f) {
        this.f = f;
        this.filterUpdate();
    },

    sort: function(s) {
        delete this.printedProducts;
        this.f.sort = s;
        this.filterUpdate();
    },

    filterPrice: function(min, max, actualChange) {

        if (typeof actualChange === typeof undefined) actualChange = true;

        if (min <= 0 && typeof max === 'string') {
            delete this.f.price;
        } else {
            this.f.price = { min: min, max: max };
        }

        if (actualChange) this.filterUpdate();
    },

    filterBrands: function(brands) {
        if (!brands || JSON.stringify(brands) == JSON.stringify({})) {
            delete this.f.brands;
        } else {
            this.f.brands = brands;
        }
        this.filterUpdate();
    },

    filterTags: function(tags) {
        if (
            typeof tags === typeof undefined ||
            !tags ||
            !tags.length ||
            JSON.stringify(tags) == JSON.stringify({})
        ) {
            delete this.f.tags;
        } else {
            this.f.tags = tags;
        }
        this.filterUpdate();
    },

    filterUpdate: function() {
        this.redraw(false);
        for (var i = 0; i < this.filterListeners.length; i++) {
            this.filterListeners[i].onFilterUpdate();
        }
        this.onFilterUpdate();
    },

    onTagsUpdated: function() {
        for (var i = 0; i < this.tagHandlers.length; i++) {
            this.tagHandlers[i].onTagUpdate(this);
        }
    },

    fetchInitial: function() {
        for (var i = 1; i <= AjaxCollection.constants.callsAtATime; i++) {
            this.fetch(i);
        }
        setTimeout(function() {
            $('.pagination.default').remove();
        }, 750);
    },

    onCollectionFetched: function() {
        console.log('...Done');
    },

    onProductsFetched: function() {},
    onFilterUpdate: function() {},
    addCustomParams: function(params) { return params; }
};

//Element Classes
function AjaxFacetedElement(nav, element) {
    this.nav = nav;
    this.element = element;

    this.element.change(this.onChange.bind(this));
}
AjaxFacetedElement.prototype = {
    onSelection: function() {}
};

function AjaxFacetedSort(nav, element, options) {
    AjaxFacetedElement.call(this, nav, element);
    this.options = options;
    this.render();
}
AjaxFacetedSort.prototype = Object.assign(Object.assign({}, AjaxFacetedElement.prototype), {
    render: function() {
        var x = '';
        for (var i = 0; i < this.options.length; i++) {
            var t = this.options[i];
            if (typeof t.name !== typeof undefined) t = t.name;
            x += '<option value="' + i + '">' + t + '</option>';
        }
        this.element.html(x);
    },

    onChange: function() {
        var value = this.element.val();
        if (!value || value >= this.options.length || !this.options[value]) return;
        this.nav.collection.sort(this.options[value]);
    },

    setValue: function(value) {
        var v = -1;
        for (var x = 0; x < this.options.length; x++) {
            if (this.options[x] != value) continue;
            v = x;
            break;
        }
        if (v < 0) return;
        this.element.val(v);
    },
});
AjaxFacetedSort.prototype.constructor = AjaxFacetedSort;
//Range (Using multirange.js)
//TODO: Allow for query to change value.
function AjaxFacetedPriceRange(nav, element) {
    AjaxFacetedElement.call(this, nav, element);
    this.rangeElement = element.find('.price-range');

    $(document).on('change', '.price-range', this.onChange.bind(this));
    $(document).on('input', '.price-range', this.render.bind(this));
    //$(document).on('input', '.price-range', this.onChange.bind(this));//May be undesirable

    this.updateMinMax();
}

AjaxFacetedPriceRange.prototype = Object.assign(Object.assign({}, AjaxFacetedElement.prototype), {
    setValue: function(value) {
        if (!value || !value.min || !value.max) return;
    },

    updateMinMax: function() {
        var pMin = this.getVal(0) / 100;
        var pMax = this.getVal(1) / 100;
        this.min = 0;
        this.max = 0;

        for (var i = 0; i < this.nav.collection.products.length; i++) {
            this.max = Math.max(this.max, this.nav.collection.products[i].data.price);
        }

        this.nav.collection.filterPrice(this.getRangeMin(), this.getRangeMax(), false);
        this.render();
    },

    productsUpdated: function() {
        //Running
        this.updateMinMax();
    },

    getVal: function(i) {
        return parseFloat(this.rangeElement.val().split(",")[i]);
    },

    getRangeMin: function() {
        var span = this.max - this.min;
        return this.min + (this.getVal(0) / 100) * span;
    },

    getRangeMax: function() {
        var span = this.max - this.min;
        var max = this.getVal(1) / 100;
        if (max == 1) return "a string";
        return this.min + (max) * span;
    },

    onChange: function() {
        this.nav.collection.filterPrice(this.getRangeMin(), this.getRangeMax());
        this.render();
    },

    render: function() {
        if (this.labelElement) {
            var min = slate.Currency.formatMoney(Math.min(this.getRangeMin()), '${{amount_no_decimals}}');
            var max = slate.Currency.formatMoney(Math.ceil(this.getRangeMax()), '${{amount_no_decimals}}');
            if (typeof this.getRangeMax() == 'string') max = "Any";

            this.labelElement.html(
                this.labelFormat
                .replace('%min%', min)
                .replace('%max%', max)
            );
        }
    },

    setLabel: function(labelElement, labelFormat) {
        this.labelElement = labelElement;
        this.labelFormat = labelFormat || "%min% - %max%";
    }
});
AjaxFacetedPriceRange.prototype.constructor = AjaxFacetedPriceRange;

//Checkbox Filter
function AjaxFacetedCheckboxFilter(nav, element) {
    AjaxFacetedElement.call(this, nav, element);
    this.checkGroup = element.find('.check-group');

    this.checkedOptions = {};
    //this.setOptions([]);
    this.options = [];
}

AjaxFacetedCheckboxFilter.prototype = Object.assign(Object.assign({}, AjaxFacetedElement.prototype), {
    onChange: function() {
        this.checkedOptions = this.getSelectedOptions();
        this.filter();
    },

    setValue: function(value) {},

    filter: function() {},

    getSelectedOptions: function() {
        var selectedOptions = {}
        this.element.find('input[type="checkbox"]').each(function() {
            var self = $(this);
            if (!self.prop('checked')) return;
            selectedOptions[self.attr('value')] = true;
        });
        return selectedOptions;
    },

    setOptions: function(options) {
        if (JSON.stringify(this.options) == JSON.stringify(options)) return;
        this.options = options;

        var x = '';
        for (var i = 0; i < options.length; i++) {
            var isChecked = this.checkedOptions[options[i]];
            x += '<li>';
            x += '<div class="checkbox">';

            x += '<input type="checkbox" data-index="' + i + '" ';
            x += (isChecked == true ? 'checked' : '');
            x += ' value="' + options[i] + '" />'

            x += '<div class="checkmark"></div>';
            x += '<label>' + options[i] + '</label>';
            x += '</div>';
            x += '</li>';
        }

        this.element.find('input[type="checkbox"]').change(this.onChange.bind(this));
        this.checkGroup.html(x);
    },

    filter: function() {

    }
});
AjaxFacetedCheckboxFilter.prototype.constructor = AjaxFacetedCheckboxFilter;
//Checkbox Filter
function AjaxFacetedBrandCheckboxFilter(nav, element) {
    AjaxFacetedCheckboxFilter.call(this, nav, element);
}
AjaxFacetedBrandCheckboxFilter.prototype = Object.assign(Object.assign({}, AjaxFacetedCheckboxFilter.prototype), {
    productsUpdated: function() {
        this.updateBrandOptions();
    },

    updateBrandOptions: function() {
        //Get the products and build a list of brands
        var brands = {}; //Other?
        for (var i = 0; i < this.nav.collection.products.length; i++) {
            var product = this.nav.collection.products[i];
            if (!product || !product.data || !product.data.vendor) continue;
            if (brands[product.data.vendor]) continue;
            brands[product.data.vendor] = true;
        }

        var brandKeys = Object.keys(brands);
        brandKeys.sort();
        this.setOptions(brandKeys);
    },

    filter: function() {
        this.nav.collection.filterBrands(this.getSelectedOptions());
    }
});
AjaxFacetedBrandCheckboxFilter.prototype.constructor = AjaxFacetedBrandCheckboxFilter;

//Checkbox Filter
function AjaxFacetedTagCheckboxFilter(nav, element) {
    AjaxFacetedCheckboxFilter.call(this, nav, element);
}
AjaxFacetedTagCheckboxFilter.prototype = Object.assign(Object.assign({}, AjaxFacetedCheckboxFilter.prototype), {
    productsUpdated: function() {},

    updateBrandOptions: function() {},

    filter: function() {}
});
AjaxFacetedTagCheckboxFilter.prototype.constructor = AjaxFacetedTagCheckboxFilter;
//Checkbox Filter
function AjaxFacetedSmartTagCheckboxFilter(nav, element, prefix) {
    AjaxFacetedCheckboxFilter.call(this, nav, element);
    this.prefix = prefix;
}
AjaxFacetedSmartTagCheckboxFilter.prototype = Object.assign(Object.assign({}, AjaxFacetedCheckboxFilter.prototype), {
    productsUpdated: function() {

    },

    isSmartTagChecked: function(tag) {
        var spl = tag.split('_')[1];
        var elm = this.element.find('[value="' + spl + '"]');
        return elm.prop('checked');
    },

    getCheckedTags: function() {
        var checked = this.element.find('input[type="checkbox"]:checked');
        var checkedTags = [];
        checked.each(function(i, d) {
            var v = $(d).val();
            if (this.contains(v)) return;
            this.push(v);
        }.bind(checkedTags));
        return checkedTags;
    },

    filter: function() {
        var col = this.nav.collection;

        var existingTags = col.f.tags || [];
        var newTags = [];

        //Remove unchecked tags
        for (var i = 0; i < existingTags.length; i++) {
            if (!existingTags[i].startsWith(this.prefix)) {
                newTags.push(existingTags[i]);
                continue;
            }
            if (!this.isSmartTagChecked(existingTags[i])) continue;
            newTags.push(existingTags[i]);
        }

        //Now add newly checked tags
        var checkedTags = this.getCheckedTags();
        for (var i = 0; i < checkedTags.length; i++) {
            var x = this.prefix + '_' + checkedTags[i];
            if (newTags.contains(x)) continue;
            newTags.push(x);
        }

        console.log('Setting tags to ' + JSON.stringify(newTags));

        col.filterTags(newTags);
    }
});
AjaxFacetedSmartTagCheckboxFilter.prototype.constructor = AjaxFacetedSmartTagCheckboxFilter;



function AjaxFacetedNav(collection, nav) {
    this.collection = collection;
    this.nav = nav;

    this.checkboxFilters = [];
    this.controls = [];
    this.sorters = [];
    this.ranges = [];
    this.priceRanges = [];

    collection.productHandlers.push(this);
    collection.collectionHandlers.push(this);
    collection.tagHandlers.push(this);
    collection.filterListeners.push(this);

    nav.on('click', '.faceted-expandable > label', function() {
        var t = $(this);
        t.closest('.faceted-expandable').toggleClass('expanded');
    });

    nav.on('click', '.faceted-nav-toggle', function() {
        var t = $(this);
        t.parent().toggleClass('expanded');
    })
}

AjaxFacetedNav.prototype = {

    onProductsUpdated: function() {
        for (var i = 0; i < this.controls.length; i++) {
            if (this.controls[i].productsUpdated) {
                this.controls[i].productsUpdated();
            }
        }
    },

    onFilterUpdate: function() {
        for (var i = 0; i < this.controls.length; i++) {
            if (this.controls[i].updateValue) {
                this.controls[i].updateValue();
            }
        }
    },

    onTagUpdate: function() {},

    sorter: function(element, options) {
        var q = false;
        if (typeof options === typeof undefined) {
            options = Object.keys(AjaxCollection.constants.sort).map(function(key) {
                return AjaxCollection.constants.sort[key];
            });
            q = true;
        }

        var sort = new AjaxFacetedSort(this, element, options);
        this.sorters.push(sort);
        this.controls.push(sort);
        if (q) sort.updateValue = function() { this.setValue(this.nav.collection.f.sort); }

        return sort;
    },

    priceRange: function(element) {
        var range = new AjaxFacetedPriceRange(this, element);
        range.updateMinMax();

        this.ranges.push(range);
        this.priceRanges.push(range);
        this.controls.push(range);
        range.updateValue = function() { this.setValue(this.nav.collection.f.price); }

        return range;
    },

    checkboxFilter: function(element) {
        var checkbox = new AjaxFacetedCheckboxFilter(this, element);

        this.checkboxFilters.push(checkbox);
        this.controls.push(checkbox);
        //TODO: Value Updater

        return checkbox;
    },

    brandCheckboxFilter: function(element) {
        var brandCheckbox = new AjaxFacetedBrandCheckboxFilter(this, element);
        this.checkboxFilters.push(brandCheckbox);
        this.controls.push(brandCheckbox);
        //TODO: Value Updater
        return brandCheckbox;
    },

    smartTagCheckboxFilter: function(element, prefix) {
        var filter = new AjaxFacetedSmartTagCheckboxFilter(this, element, prefix);
        this.checkboxFilters.push(filter);
        this.controls.push(filter);
        //TODO: Value Updater
        return filter;
    }
};
$('.newsletter-form').on('submit', function(e) {
    $(this).fadeOut()
})

function repositionAlgoliaSearch(searchText, algoliaContainer) {
    if (typeof searchText === typeof undefiend || !searchText || !searchText.length) return;
    if (typeof algoliaContainer === typeof undefined || !algoliaContainer || !algoliaContainer.length) return;

    var form = searchText.closest('.search-bar');
    if (typeof form === typeof undefined || !form || !form.length) return;
    algoliaContainer.css('top', (searchText.offset().top + searchText.outerHeight()) + 'px');
    algoliaContainer.css('left', form.offset().left + 'px');
    algoliaContainer.css('width', form.innerWidth() + 'px');
}

$(document).on('acv', function(e, a) {
    //console.log(a);
    var f = a.$container;
    var inp = $('[name="q"][data-index="' + f.attr('data-index') + '"]');
    $('.search-query-href').attr('href', '/search?q=' + encodeURIComponent(inp.val()));

    repositionAlgoliaSearch(inp, f);

    var form = inp.closest('.search-bar');
    form.addClass('active');
    $('.algolia-autocomplete').addClass('is-required');
});

$(window).on('resize', function() {
    $('.search-text').each(function() {
        var self = $(this);
        var al = $('.algolia-autocomplete[data-index="' + self.attr('data-index') + '"]').css('display', 'none');
        repositionAlgoliaSearch(self, al);
    });
});

$(document).on('ach', function(e, a) {
    var inp = $('[name="q"][data-index="' + a.$container.attr('data-index') + '"]')
    var form = inp.closest('.search-bar');
    form.removeClass('active');
    $('.algolia-autocomplete').removeClass('is-required');
});

$(document).ready(function() {
    setTimeout(function() {
        var i = 0;
        $('.algolia-autocomplete').each(function() {
            var self = $(this);
            self.attr('data-index', i);
            i++;
        });

        i = 0;
        $('.search-text, .aa-input').each(function() {
            var self = $(this);
            var id = self.attr('id');
            self.attr('data-index', i);
            i++;

            self.on('blur focusout', function() {
                var self = $(this);
                $('.algolia-autocomplete[data-index="' + self.attr('data-index') + '"]').css('display', 'none');
                self.closest('.search-bar').removeClass('active');
            });
        });

    }, 16);
});

/*
 * TODO: Add support for snippets (Like a product name or whatever)
 */
function ShareMenu(element) {
    this.element = element;
    this.links = [];
    this.url = window.location.origin + this.element.attr('data-share-url');



    //Setup social links
    this.element.find('[data-share-link]').each(function(e, element) {
        var self = $(element);
        var handle = self.attr('data-share-handle');
        this.register(self, handle);
    }.bind(this));
}

ShareMenu.prototype = {
    register: function(link, type) {
        this.links.push(link);

        switch (type) {
            case 'facebook':
                {
                    this.registerFacebook(link);
                    break;
                }
            case 'twitter':
                {
                    this.registerTwitter(link);
                    break;
                }
            case 'pinterest':
                {
                    this.registerPinterest(link);
                    break;
                }
            case 'google-plus':
                {
                    this.registerGooglePlus(link);
                    break;
                }
            default:
                {
                    break;
                }
        }
    },

    registerFacebook: function(e) {
        //Generate a full url
        var fullURL = '//www.facebook.com/sharer.php?u=';
        fullURL += encodeURIComponent(this.url);
        e.attr('href', fullURL);
    },

    registerTwitter: function(e) {
        var fullURL = '//twitter.com/share?url=';
        fullURL += encodeURIComponent(this.url);
        e.attr('href', fullURL);
    },

    registerPinterest: function(e) {
        var fullURL = '//pinterest.com/pin/create/link/?url=';
        fullURL += encodeURIComponent(this.url);
        e.attr('href', fullURL);
    },

    registerGooglePlus: function(e) {
        var fullURL = '//plus.google.com/share?url=';
        fullURL += encodeURIComponent(this.url);
        e.attr('href', fullURL);
    }
};

$(document).ready(function() {
    $('[data-social-menu]').each(function() {
        var self = $(this);
        new ShareMenu(self);
    });
});

function ProductQuantitySelector(element) {
    this.element = element;
    this.counterContainer = element.find('.product-amount');
    this.counter = element.find('[name="quantity"]');
    this.minusButton = element.find('.product-minus');
    this.addButton = element.find('.product-plus');

    //Event Handlers
    this.element.on('click', '.product-plus', this.add.bind(this));
    this.element.on('click', '.product-minus', this.minus.bind(this));
    this.counter.on('change keypress keyup keydown paste cut copy blur', this.counterChange.bind(this));
    this.counter.on('blur', this.onBlur.bind(this));

    this.callbacks = [];

    if (this.element.attr('data-max')) {
        this.max = parseInt(this.element.attr('data-max'));
    }

    this.updateStyling();
}

ProductQuantitySelector.prototype = {
    maxAvailable: function() {
        return typeof this.max === typeof undefined ? 999999999 : this.max;
    },

    minAvailable: function() {
        if (this.maxAvailable() == 0) return 0;
        if (this.zero) {
            return 0;
        }
        return 1;
    },

    getAmount: function() {
        return parseInt(this.counter.val());
    },

    addCallback: function(cb) {
        this.callbacks.push(cb);
    },

    allowZero: function(callback) {
        this.zero = true;
        this.zeroFunction = callback;
        this.updateStyling();
    },

    disallowZero: function() {
        this.zero = false;
        if (this.getAmount() < this.minAvailable()) {
            this.setAmount(this.minAvailable());
        }
        this.updateStyling();
    },

    setMax: function(max) {
        if (max === -1) {
            delete this.max;
        } else {
            this.max = max;
            if (this.getAmount() > max) this.setAmount(max);
        }
        if (this.getAmount() <= 0) this.setAmount(1);
    },

    add: function(amt) {
        if (amt instanceof Event) {
            amt.preventDefault();
            amt.stopPropagation();
        }
        if (typeof amt === typeof undefined || typeof amt !== 'number') amt = 1;
        this.setAmount(this.getAmount() + amt);
    },

    minus: function(amt) {
        if (amt instanceof Event) {
            amt.preventDefault();
            amt.stopPropagation();
        }
        if (typeof amt === typeof undefined || typeof amt !== 'number') {
            amt = 1;
        }
        this.setAmount(this.getAmount() - amt);
    },

    setAmount: function(amt) {
        if (amt == this.getAmount()) return;
        if (amt < this.minAvailable()) amt = this.minAvailable();
        if (amt > this.maxAvailable()) amt = this.maxAvailable();

        if (amt == 0 && typeof this.zeroFunction !== typeof undefined) {
            var result = this.zeroFunction();
            if (!result) return;
        }

        this.counter.val(amt);
        this.updateStyling(amt);

        for (var i = 0; i < this.callbacks.length; i++) {
            this.callbacks[i](amt);
        }
    },

    updateStyling: function(amt) {
        if (typeof amt === typeof undefined) amt = this.getAmount();

        //Adjust button styling
        if (amt >= this.maxAvailable()) {
            this.addButton.addClass('disabled');
        } else {
            this.addButton.removeClass('disabled');
        }

        if (amt <= this.minAvailable()) {
            this.minusButton.addClass('disabled');
        } else {
            this.minusButton.removeClass('disabled');
        }

        if (amt == this.minAvailable() && amt == this.maxAvailable()) {
            this.counterContainer.addClass('disabled');
            this.counter.attr('disabled', 'disabled');
        } else {
            this.counterContainer.removeClass('disabled');
            this.counter.removeAttr('disabled');
        }
    },

    counterChange: function(e) {
        if (this.counter.val().replace(/\D/g, '') == '') {
            this.counter.val('');
            return;
        }
        if (this.counter.val() == '') return;
        this.setAmount(this.getAmount());
    },

    onBlur: function(e) {
        if (this.counter.val() == '') {
            this.counter.val(0);
        }
        var v = this.getAmount();

        for (var i = 0; i < this.callbacks.length; i++) {
            this.callbacks[i](v);
        }
    }
};

function createProductQuantitySelector(price, quantity, max, available, add_to_cart) {
    if (typeof quantity === typeof undefined) quantity = 1;
    if (typeof max === typeof undefined) max = -1;
    if (typeof available === typeof undefined) available = true;
    if (typeof add_to_cart === typeof undefined) add_to_cart = true;
    var x = '<div class="product-quantity-selector';
    if (!add_to_cart) x += ' no-button';
    x += '"';
    if (max > -1) x += ' data-max="' + max + '"';
    x += '>'; //Open Selector

    x += '<div class="quantity-box">'; //Open Quantity BOx
    x += '<div class="product-minus'; //Open Minus
    if (!available || quantity <= 1) x += ' disabled';
    x += '">';
    x += '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/></svg>';
    x += '</div>'; //Close Minus

    x += '<div class="product-amount';
    if (!available) x += ' disabled';
    x += '">'; //Open Product amt
    x += '<input type="number" value="' + quantity + '" name="quantity"';
    if (!available) x += ' disabled';
    x += ' />'
    x += '</div>'; //Close product amt

    x += '<div class="product-plus';
    if (!available || (max >= 0 && quantity >= max)) x += ' disabled';
    x += '">'; //Open plus
    x += '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/></svg>';
    x += '</div>'; //Close plus
    x += '</div>'; //Close Quantity box

    if (add_to_cart) {
        x += '<div class="add-to-cart-wrapper">'; //Open Add to cart
        x += '<button type="submit" class="btn btn-block btn-add-to-cart" ';
        x += 'name="add data-add-to-cart';
        if (!available || price <= 0) {
            x += ' disabled="disabled';
        }
        x += '">'; //Open Button
        x += '<span data-add-to-cart-text>';
        if (available && price > 0) {
            x += window.theme.strings.addToCart;
        } else {
            x += window.theme.strings.soldOut;
        }
        x += '</span>';
        x += '</button>' //Close Button
        x += ' </div>'; //Close Add to cart
    }

    x += '</div>'; //Close Selector
    return x;
}

var newsletter_popup_cookie_name = 'nsltckpp'; //Name to help obfuscate

function closeNewsletterPopup() {
    var popup = $('.popup-overlay.open');
    popup.removeClass('open');
    $(document.body).removeClass('popup-open');

    Cookies.set(newsletter_popup_cookie_name, new Date(), { expires: 7 });
}

function showNewsletterPopup() {
    var popup = $('.popup-overlay');
    popup.addClass('open');
    $(document.body).addClass('popup-open');
}

$(document).ready(function() {
    setTimeout(function() {
        if (Cookies.get(newsletter_popup_cookie_name)) {
            var dateStr = Cookies.get(newsletter_popup_cookie_name);
            var dateObj = new Date(dateStr);
            if (!dateObj || !dateObj.isValidDate()) {
                Cookies.remove(newsletter_popup_cookie_name);
            }
            return;
        }
        showNewsletterPopup();
    });
})

window.ppt = window.ppt || [];

function ProductPageThumbnails(container) {
    this.id = window.ppt.length;
    this.container = container;
    this.firstTime = true;
    this.navContainer = container.find('.nav-container');
    this.slideContainer = container.find('.main');

    //Load in the JSON data
    this.jsonContainer = container.find('[type="text/json"]');
    this.data = JSON.parse(this.jsonContainer.html());

    //Create our slider elements
    var thumbs = '<div class="nav">';
    var thumbs_gallery = '';
    var slides = '';
    var dpr = window.getDevicePixelRatio();

    //Determine the max ratio.
    this.highestRatio = 0;
    for (var i = 0; i < this.data.length; i++) {
        console.log(this.data[i].ratio);
        this.highestRatio = Math.max(parseInt(this.data[i].ratio), this.highestRatio);
    }
    // Ensure the ratio is not 0
    this.highestRatio = this.highestRatio < 1 ? 1.0 : this.highestRatio;

    //Desktop thumbs
    if ($('.swatch.clearfix').length <= 0) {
        for (var i = this.data.length - 1; i >= 0; i--) {
            var im = this.data[i];
            thumbs += '<div class="thumb thumb-' + i + ' thumb-desktop" data-index="' + i + '" data-container="' + this.id + '">';
            thumbs += '<div class="box-sizer square"></div>';
            thumbs += '<div class="thumb-image-container"><img src="' + (this.data[i]['dpr-1x'].small) + '" alt=""></div>';
            thumbs += '</div>';

            thumbs_gallery += '<a href="#" data-index="' + i + '" data-image="' + (this.data[i]['dpr-1x'].medium) + '" data-zoom-image="' + (this.data[i]['dpr-4x'].large) + '">';
            thumbs_gallery += '<img src="' + (this.data[i]['dpr-1x'].small) + '" alt="" class="slide-image"/>';
            thumbs_gallery += '</a>';
        }
        if ($(".video-thumbnail").length > 0) {
            var i = this.data.length;
            var video_thumb = $(".video-thumbnail").html();
            var video_embed = $(".video.product-single__media").html();
            thumbs += '<div class="thumb thumb-' + i + ' thumb-desktop" data-index="' + i + '" data-container="' + this.id + '">';
            thumbs += '<div class="box-sizer square"></div>';
            thumbs += '<div class="thumb-image-container">' + video_thumb + '</div>';
            thumbs += '</div>';
        }
    }


    for (var i = 0; i < this.data.length; i++) {
        //Slide will always be the max ratio
        slides += '<div class="slide slide-' + i + '" data-index="' + i + '" data-container="' + this.id + '">';
        slides += '<div class="box-sizer" style="padding-bottom: ' + Math.round(100 / this.highestRatio) + '%"></div>';
        slides += '<a href="#" data-lity-target="' + (this.data[i]['dpr-4x'].large) + '" class="slide-image-container" data-lity></a>';
        slides += '</div>';
    }
    if ($(".video-thumbnail").length > 0) {
        var i = this.data.length;
        var video_embed = $(".video.product-single__media").html();
        slides += '<div class="slide slide-' + i + '" data-index="' + i + '" data-container="' + this.id + '">';
        slides += '<div class="box-sizer" ></div>';
        slides += video_embed;
        slides += '</div>';
    }

    thumbs += '</div>';

    if (thumbs.indexOf('thumb-1') == -1) {
        $('.product-thumbnails-wrapper').removeClass('product-has-thumbnails');
    }

    this.navContainer.html(thumbs);
    this.slideContainer.html(slides);
    $('#zoom-gallery-thumb').html(thumbs_gallery);

    $('.slide-image-container').on('click', function(e) {
        e.preventDefault();
        var t_leng = $('.product-thumbnail-wrapper .nav .thumb').length;

        var i_index = $('.product-thumbnail-wrapper .thumb-desktop.active').data('index'),
            m_img = $(this).attr('href'),
            z_img = $(this).attr('data-lity-target');

        $("#zoom-img").attr({
            "src": m_img,
            "data-zoom-image": z_img
        });

        $("#zoom-img").ezPlus({
            gallery: 'zoom-gallery-thumb',
            cursor: 'point',
            galleryActiveClass: "active",
            zoomType: 'lens',
            containLensZoom: true,
            lensShape: 'round',
            lensSize: 320
        });

        $('#zoom-gallery-thumb a[data-index=' + i_index + ']').trigger("click");
        $('.zoom-box-wrapper').addClass('active');
        if (t_leng > 1) {
            $('.zoom-gallery-arrow').removeClass('hide');
        } else {
            $('.zoom-gallery-arrow').addClass('hide');
        }
        return false;
    });

    //this.navSimpleBar = new SimpleBar(this.navContainer[0]);

    this.container.attr('data-container', this.id);
    this.navContainer.attr('data-container', this.id);
    this.slideContainer.attr('data-container', this.id);

    this.slideContainer.on('init', this.onSlideInit.bind(this));
    this.slideContainer.on('beforeChange', this.onSlideChange.bind(this));
    this.slideContainer.slick({
        // dots: window.matchMedia("(max-width: 749px)").matches,
        swipe: true,
        arrows: window.matchMedia("(max-width: 749px)").matches,
        cssEase: 'cubic-bezier(0.23, 1, 0.32, 1)',
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        responsive: [{
            breakpoint: 480,
            settings: {
                dots: true
            }
        }]
    });

    this.resizeElements();

    this.navContainer.on('click touchstart', '.thumb', function() {
        var self = $(this);
        if (self.hasClass('active')) return;
        var id = self.attr('data-index');
        var container = self.attr('data-container');
        $('.main[data-container="' + container + '"]').slick('slickGoTo', id)
    });

    window.ppt.push(this); //Start tracking

    /*var x = $(this.navSimpleBar.getScrollElement());
    x.scrollTop(x.prop("scrollHeight"));+*/
}


ProductPageThumbnails.prototype = {
    fetchSlide: function(index) { return this.slideContainer.find('[data-index="' + index + '"]'); },
    fetchThumb: function(index) {
        var selector = '[data-index="' + index + '"]';
        if (this.stack) {
            selector += '.thumb-mobile';
        } else {
            selector += '.thumb-desktop';
        }
        return this.navContainer.find(selector);
    },

    setSlide: function(index, updateCarousel) {
        if (typeof updateCarousel === typeof undefined || updateCarousel) {
            if (this.firstTime === true) {
                this.slideContainer.slick('slickGoTo', 0);
                this.firstTime = false;
            } else {
                this.slideContainer.slick('slickGoTo', index);
            }
        }

        this.navContainer.find('.thumb').removeClass('active');
        var thumb = this.fetchThumb(index);
        thumb.addClass('active');
        this.checkStack();

        // if(!this.stack) {
        //   var x = $(this.navSimpleBar.scrollContentEl).scrollTop() + thumb.position().top;
        //   x -= this.navContainer.height()/2;
        //   x += thumb.height()/2;
        //   //x = $(this.navSimpleBar.scrollContentEl).scrollTop() + thumb.position().top;
        //   $(this.navSimpleBar.scrollContentEl).stop().animate({scrollTop: x}, 200);
        // }
        return true;
    },

    setSlideByID: function(id) {
        for (var i = 0; i < this.data.length; i++) {
            if (this.data[i].id != id) continue;
            return this.setSlide(i);
        }
        return false;
    },

    onSlideInit: function(e, s, j, k, q, l) {
        this.navContainer.find('.thumb').removeClass('active');
        this.fetchThumb(s.currentSlide).addClass('active');
    },

    onSlideChange: function(event, slick, currentSlide, nextSlide) {
        this.setSlide(nextSlide, false);
    },

    checkStack: function() {
        this.stack = window.matchMedia("(max-width: 749px)").matches;
        // this.stack = false;
    },

    resizeElements: function() {
        //TODO: Async Loading?
        var thumbnailSize = 90;
        this.checkStack();
        var dpr = window.getDevicePixelRatio();
        var slideWidth;

        if (this.stack) {
            var container = this.container.innerWidth(); //Keeps images roughly square
            remaining = container - thumbnailSize;

            this.slideContainer.css('width', '100%');
            this.slideContainer.css('height', 'initial');
            this.slideContainer.css('min-height', remaining + 'px');
            // this.navContainer.css('width', '100%');
            // this.navContainer.css('height', 'initial');
            //this.navContainer.height(thumbnailSize);

            slideWidth = this.container.innerWidth();
        } else {
            var container = this.container.innerWidth();
            var remaining = container - thumbnailSize;
            var maxHeight = remaining / this.highestRatio;

            maxHeight = Math.max(maxHeight, $('.product-price').height());

            //this.navContainer.width(thumbnailSize);
            //this.navContainer.height(maxHeight);
            //this.slideContainer.width(remaining);
            //this.slideContainer.height(maxHeight);
            slideWidth = remaining;
        }

        //Now load that bests suits the container
        for (var i = 0; i < this.data.length; i++) {
            var im = this.data[i];
            var set;

            if (dpr > 2) {
                set = im['dpr-4x'];
            } else if (dpr > 1) {
                set = im['dpr-2x'];
            } else {
                set = im['dpr-1x'];
            }

            var imThumb = set.small;
            var imSlide;
            imSlide = set.large;

            if (slideWidth > 600) {
                imSlide = set.large;
            } else if (slideWidth > 128) {
                imSlide = set.medium;
            } else {
                imSlide = set.small;
            }

            //Thumbnails
            var t = this.fetchThumb(i);
            t = t.find('.thumb-image-container img');
            t.attr('src', imThumb);

            //Image
            var s = this.fetchSlide(i);
            var sa = s.find('.slide-image-container');
            sa.attr('href', imSlide);
            var simg = sa.find('img');
            if (simg.length) simg.remove();
            sa.append('<img src="' + imSlide + '" width="' + im.width + '" height="' + im.height + '" />');
            simg = sa.find('img');

            simg.on('load', this.onImageLoad.bind(this));

            //Refresh slider
            this.slideContainer.slick('setPosition');
        }
    },

    onImageLoad: function() {
        this.slideContainer.slick('setPosition');
    }
}

/*$(document).ready(function() {
  $('.product-thumbnails').each(function() {
    var container = $(this);
    new ProductPageThumbnails(container);
  });
});*/

$(window).on('resize', function() {
    for (var i = 0; i < window.ppt.length; i++) {
        window.ppt[i].resizeElements();
    }
});

function Tabs(container) {
    this.container = container;

    //Assign tab headers and tab bodies their respective tab ids
    this.container.find('.tab-header').each(function(index, value) {
        var self = $(this);
        self.attr('data-index', index);
    });
    this.container.find('.tab-body').each(function(index, value) {
        var self = $(this);
        self.attr('data-index', index);
    });

    //Listen for tab header click events
    this.container.on('click', '.tab-header', function(e, j, b, f) {
        var self = $(e.target);
        this.selectTab(self.attr('data-index'));
    }.bind(this));


    // When tab-headers can scroll, check if scrolled to far right an remove fade
    $('.tab-headers').scroll(function(event) {
        var elem = $(event.currentTarget);
        if (elem[0].scrollWidth - elem.scrollLeft() <= elem.outerWidth() + 20) {
            $('.tab-headers-container').removeClass('has-fade');
        } else {
            $('.tab-headers-container').addClass('has-fade');
        }
    });

}

Tabs.prototype = {
    selectTab: function(index) {
        this.container.find('.tab-body').removeClass('active');
        this.container.find('.tab-header').removeClass('active');
        this.container.find('.tab-body[data-index="' + index + '"]').addClass('active');
        this.container.find('.tab-header[data-index="' + index + '"]').addClass('active');
    },
    findTab: function(selector) {
        //Returns the index of the tab by the supplied data-name attribute.
        var tab = this.container.find('.tab-header[tab-name="' + selector + '"]');
        return parseInt(tab.attr('data-index'));
    }
}

$(document).ready(function() {
    $('.tabs').each(function() {
        var tabs = new Tabs($(this));
        window.tabs = window.tabs || [];
        window.tabs.push(tabs);
    });

    $('[data-tab-nav]').click(function(e) {
        e.preventDefault();

        var self = $(this);
        var navTab = self.attr('data-tab');
        var tab = window.findTab(self.attr("data-target"));
        if (!tab) return;
        tab.selectTab(tab.findTab(navTab));
    });
})

window.findTab = window.findTab || (function(search) {
    window.tabs = window.tabs || [];
    for (var i = 0; i < window.tabs.length; i++) {
        var tab = window.tabs[i];
        if (typeof tab === typeof undefined) continue;
        if (!tab) continue;
        if (typeof tab.container === typeof undefined) continue;
        if (!tab.container.length) continue;
        if (!tab.container.is(search)) continue;
        return tab;
    }
    return null;
});
$(document).on('click', '[data-simple-toggle]', function(e) {
    e.stopPropagation();
    e.preventDefault();

    var self = $(this);
    var target = $(self.attr("data-target"));
    target.toggleClass(self.attr("data-class"));

    if (self.attr('data-text-toggled')) {
        if (target.hasClass(self.attr('data-class'))) {
            self.html(self.attr('data-text-toggled'));
        } else {
            self.html(self.attr('data-text-untoggled'));
        }
    }
});

$(document).on('click', '[data-toggle="collapse"]', function(e) {
    e.preventDefault();
    var self = $(this);
    var target = $(self.attr("href"));
    target.toggleClass(self.attr('data-class') || 'visible');

    var listeners = $('[href="' + self.attr("href") + '"]');
    listeners.toggleClass('collapsed');
    listeners.toggleClass('not-collapsed');
})

function AjaxCart(menu) {
    this.menu = menu;
    this.container = menu.container;
    this.body = this.container.find('.ajax-cart-body');

    $(window).on('cart-changed', function(e, d) {
        this.setData(d);
    }.bind(this));

    this.container.on('click touchstart', '.product-remove', this.removeProduct);
}

AjaxCart.prototype = {
    setData: function(d) {
        var x = '';

        x += '<h1 class="title">Your Cart</h1>';

        var hasItems = typeof d !== typeof undefined && typeof d.items !== typeof undefined && typeof d.items.length !== typeof undefined && d.items.length;
        if (hasItems) {
            for (var i = 0; i < d.items.length; i++) {
                var item = d.items[i];
                if (!item.title || !item.url) {
                    continue;
                }
                x += '<div class="ajax-cart-item" data-variant="' + item.id + '">';
                x += '<div class="ajax-cart-loader">' + generateLoader() + '</div>';
                x += '<div class="product-image-section">';
                x += '<a href="' + item.url + '" class="product-image">';
                x += '<img src="' + window.slate.Image.getSizedImageUrl(item.image, '500x') + '" />';
                x += '</a>';
                x += '</div>';

                x += '<div class="product-details">';

                x += '<span class="product-title">'
                x += '<span class="product-remove" data-variant="' + item.id + '">&times;</span>';
                x += '<a href="' + item.url + '">';
                x += item.title.replace('&', '&amp;').replace('<', '&lt;').replace('  ', ' &nbsp;');
                x += '</a>';
                x += '</span>';

                x += '<span class="product-price">' + window.slate.Currency.formatMoney(item.line_price) + '</span>';

                x += '<div class="product-qty">';
                x += createProductQuantitySelector(item.line_price, item.quantity, undefined, undefined, false);
                x += '</div>';

                x += '</div>';

                x += '</div>';
            }
        } else {
            x += '<p class="subtitle">Your cart is empty</p>';
        }

        this.body.html(x);

        this.body.find('.product-quantity-selector').each(function(i, e) {
            var self = $(e)
            var selector = new ProductQuantitySelector(self);
            var o = {
                cart: this,
                selector: self
            }
            selector.allowZero(this.onZero.bind(o))
            selector.addCallback(this.onQuantity.bind(o));
        }.bind(this));

        $('[data-cart-total]').html(window.slate.Currency.formatMoney(d.total_price));
    },

    removeProduct: function() {
        //Not bound, this = the object firing the event
        var self = $(this);
        if (!self.data('variant')) return;
        self.closest('.ajax-cart-item').find('.ajax-cart-loader').addClass('visible');
        $.ajax({
            url: '/cart/change.js',
            method: 'POST',
            dataType: "json",
            data: {
                quantity: 0,
                id: self.data('variant')
            },
            success: function(data) {
                Shopify.getCart(function(cart) {
                    $(window).trigger('cart-changed', cart);
                }, data);
            },
            error: function(e) {
                console.error(e);
                window.location.reload();
            }
        });
    },

    open: function() { this.menu.open(); },
    close: function() { this.menu.close(); },
    isOpen: function() { return this.menu.isOpen(); },
    toggleOpen: function() { this.menu.toggleOpen(); },
    onZero: function() {
        var cart = this.cart;
        var selector = this.selector;
        var item = selector.closest('.ajax-cart-item');
        cart.removeProduct.bind(item)();
    },
    onQuantity: function(e) {
        var cart = this.cart;
        var selector = this.selector;
        var item = selector.closest('.ajax-cart-item');
        item.closest('.ajax-cart-item').find('.ajax-cart-loader').addClass('visible');
        $.ajax({
            url: '/cart/change.js',
            method: 'POST',
            dataType: "json",
            data: {
                quantity: e,
                id: item.data('variant')
            },
            success: function(data) {
                Shopify.getCart(function(cart) {
                    $(window).trigger('cart-changed', cart);
                }, data);
            },
            error: function(e) {
                console.error(e);
                window.location.reload();
            }
        });
    }
};

//Wrap
$(document).ready(function() {
    if (window.ajaxCart) return;
    var menuObject = window.findMenu('.ajax-cart-menu');
    var menuWrapper = new AjaxCart(menuObject);
    menuWrapper.setData(window.cart);
    window.ajaxCart = menuWrapper;
});


/*

 *  Accordion

 *    Scripts for accordion sliders

 *

 *  NOTES:

 *    This has been modified to not use data attributes due to complcations from client

 *

 *  Dependencies:

 *    jQuery - jQuery is required for event listeners

 *    styles/objects/_accordion.scss - Styles for the accordion

 *

 *  Version:

 *    1.1.0- 2018/02/22

 */

function Accordion(container) {

    this.container = container;

    this.id = (window.accordions = window.accordions || []).length;

    this.container.attr('data-id', this.id);

    //this.slides = this.container.find('[data-accordion-slide]');

    this.slides = this.container.find('.accordion-slide');



    this.multiple = this.container.data('multiple') || false;



    //Asign indicies

    this.slides.each(function(e) {

        var self = $(this);

        self.attr('data-id', e);

        //self.find('[data-accordion-title]').attr('data-id', e);

        self.find('.accordion-title').attr('data-id', e);

    });



    //Event Handlers

    //this.container.on('click', '[data-accordion-title]', this.changeSlide.bind(this));

    this.container.on('click', '.accordion-title', this.changeSlide.bind(this));

}



Accordion.prototype = {

    changeSlide: function(e, b) {

        if (this.container === typeof undefined) return;

        var self = $(e.currentTarget);

        var index = self.data('id');

        if (typeof index === typeof undefined) return;

        this.setSlide(index);

    },



    getSlideByIndex: function(index) {

        //return this.container.find('[data-accordion-slide][data-id="'+index+'"]');

        return this.container.find('.accordion-slide[data-id="' + index + '"]');

    },



    setSlide: function(index) {

        var slide = this.getSlideByIndex(index);



        console.log(slide);



        if (slide.attr('data-expanded') == "true") {

            //Already expanded, just shrink this one

            slide.removeClass('is-expanded');

            slide.attr('data-expanded', false);

        } else {

            if (!this.multiple) {

                this.slides.removeClass('is-expanded');

                this.slides.attr('data-expanded', false);

            }

            slide.addClass('is-expanded');

            slide.attr('data-expanded', true);

        }



        this.onExpand(index, slide);

    },



    onExpand: function(index, slide) {



    }

}



$(document).ready(function() {

    //$('[data-accordion]').each(function() {

    $('.accordion').each(function() {

        var self = $(this);

        var accordion = new Accordion(self);

        window.accordions = window.accordions || [];

        window.accordions.push(accordion);

    });

});

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

$(document).ready(function() {
    $('.address-country-option').each(function() {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
        $('.address-form-new').toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function(e) {
        e.preventDefault();
        var formId = $(this).data('form-id');
        $('.edit-address-form-' + formId).toggleClass('hide');
        $(this).closest('.address').toggleClass('form-shown');
    });

    $('.address-delete').on('click', function(e) {
        e.preventDefault();
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
        }
    });


    $('.add-address-form').each(function(e) {
        var self = $(this);
        var form = self.find('form');
        form.on('submit', function() {
            var self = $(this);
            self.find('.form-loader').addClass('visible')
        })
    });
});

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
    var config = {
        recoverPasswordForm: '#RecoverPassword',
        hideRecoverPasswordLink: '#HideRecoverPasswordLink'
    };

    if (!$(config.recoverPasswordForm).length) {
        return;
    }

    checkUrlHash();
    resetPasswordSuccess();

    $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

    function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
    }

    function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
            toggleRecoverPasswordForm();
        }
    }

    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
        $('#RecoverPasswordForm').toggleClass('hide');
        $('#CustomerLoginForm').toggleClass('hide');
    }

    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
        var $formState = $('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!$formState.length) {
            return;
        }

        // show success message
        $('#ResetSuccess').removeClass('hide');
    }
})();

//Custom Faceted Nav
function OzHairFacetedNav(collection, facetedNav) {
    AjaxFacetedNav.call(this, collection, facetedNav);
    //Setup Filters
    this.sortBy = this.sorter(facetedNav.find('.sort-by'));
    this.pricer = this.priceRange(facetedNav.find('.price-range-container'));
    this.pricer.setLabel($('.price-range-result'), 'From: %min% - %max%');

    //Brand
    this.brand = this.brandCheckboxFilter(facetedNav.find('.faceted-expandable.group-brand'));
}
OzHairFacetedNav.prototype = Object.assign(Object.assign({}, AjaxFacetedNav.prototype), {
    onTagUpdate: function(collection) {
        AjaxFacetedNav.prototype.onTagUpdate.call(this, collection);
        this.nav.find('.filter-tag').remove();

        //First Tag is always whatever is related most to this particular collection...
        if (!collection.tag_filters) return;
        var keys = Object.keys(collection.tag_filters);

        var arrowCode = $('.expand-arrow-code').html();

        var genChildren = function(k, v) {
            var q = '';
            for (var m = 0; m < v.length; m++) {
                q += '<li>';
                q += '<div class="checkbox">';
                q += '<input data-index="' + m + '" value="' + v[m] + '" type="checkbox" />';
                q += '<div class="checkmark"></div>';
                q += '<label>' + v[m] + '</label>';
                q += '</div>';
                q += '</li>';
            }
            return q;
        };

        var gen = function(k, v) {
            var q = '';
            q += '<div class="faceted-nav-group faceted-expandable filter-tag expanded" data-prefix="' + k + '">';
            q += '<label for="brand">' + k + ' ' + arrowCode + '</label>';
            q += '<div class="expand-group">';
            q += '<ul class="check-group">';
            q += genChildren(k, v);
            q += '</ul>';
            q += '</div>';
            q += '</div>';
            return q;
        }

        var aftsrt = ''; //After Sort
        var aftprc = ''; //After Price Range
        var brands = this.nav.find('.group-brand');

        for (var i = 0; i < keys.length; i++) {
            var k = keys[i];
            var v = collection.tag_filters[keys[i]];
            if (!k || !v) continue;

            if (k.startsWith(this.collection.title)) {
                if (k.includes("Category")) {
                    aftsrt += gen(k, v);
                } else if (k.endsWith('Type')) {
                    aftsrt += gen(k, v);
                }
            }

            if (!brands.length) {
                if (k.endsWith('Ranges')) {
                    aftsrt += gen(k, v);
                } else if (k == "Category") {
                    aftsrt += gen(k, v);
                }
            }

            if (k == 'Concerns') {
                aftprc += gen(k, v);
            }
        }

        if (brands.length) {
            brands.after(aftsrt);
        } else {
            this.nav.find('.group-sort-by').after(aftsrt);
        }

        this.nav.find('.group-price-range').after(aftprc);
        this.nav.find('.expand-group').each(function() {
            new SimpleBar(this);
        });

        //Register filters
        this.nav.find('.filter-tag').each(function(i, obj) {
            var self = $(obj);
            this.smartTagCheckboxFilter(self, self.attr('data-prefix'));
        }.bind(this));
    }
});
//OzHairFacetedNav.prototype.constructor = OzHairFacetedNav;


//Custom Collection Page
function OzHairCollectionPage(handle, container, pagination, facetedNav) {
    this.page = 1; //How many products we're going to render to start

    if (window.query && window.query.page) {
        this.page = parseInt(window.query.page) || 1;
    }

    AjaxCollection.call(this, handle, container);


    this.perPage = 4 * 4; //Rows * Cols
    this.pagination = pagination;
    this.facetedNav = new OzHairFacetedNav(this, facetedNav);
    this.loading = [];

    //Handlers
    this.pagination.on('click touchend', '[data-pagination]', this.pageChange.bind(this));
    window.onpopstate = this.onHistoryState.bind(this);
    //this.viewMore.click(this.showMore.bind(this));
}

OzHairCollectionPage.prototype = Object.assign(Object.assign({}, AjaxCollection.prototype), {
    paginate: function(all) {
        //Pagination code
        var t = [];
        var p = (this.page - 1) * this.perPage;
        var e = (this.page) * this.perPage;

        for (var i = p; i < Math.min(e, all.length); i++) {
            t.push(all[i]);
        }
        return t;
    },

    onFilterUpdate: function() {
        AjaxCollection.prototype.onFilterUpdate.call(this);
    },

    onHistoryState: function(e) {
        if (!e.state || !e.state.page) return;
        this.setPage(e.state.page, false);
    },

    setPage: function(p, updateState) {
        if (typeof updateState === typeof undefined) updateState = true;

        if (updateState) {
            var title = document.title.replace("Page " + this.page, "Page " + p);
            var url = window.location.href;
            if (url.includes("page=")) {
                url = url.replace("page=" + this.page, "page=" + p);
            } else {
                url += (url.includes("?") ? "&" : "?") + "page=" + p;
            }
            history.pushState({
                page: p
            }, title, url);
        }

        this.page = p;
        this.redraw(false);
        this.renderTimeout = setTimeout(function() {
            this.redrawPagination();
        }.bind(this), 500);
    },

    pageChange: function(e) {
        e.preventDefault();
        e.stopPropagation();

        //Also need to sub the navbar height on desktop (if any)
        var nb = $('.navbar-desktop');
        var h = nb.outerHeight() || 0;
        console.log(this.container.offset().top - h);

        $('html, body').stop().animate({
            scrollTop: this.container.offset().top - h - 24
        }, 300, function() {

        });

        var self = $(e.currentTarget);
        var id = self.attr('data-page');
        this.setPage(parseInt(id));
    },

    redrawPagination: function() {
        var x = '';
        var show = 5;
        var start = this.page - show;
        var pagesU = parseFloat(this.unpaginatedProductCount) / parseFloat(this.perPage);
        var pages = Math.ceil(pagesU);
        var end = Math.min(this.page + show, pages + 1);
        for (var i = start; i < end; i++) {
            if (i < 1) continue;

            var p = i;
            var cur = i == this.page;
            var isStart = i == start && i != 1;
            var isEnd = i == end && i != pages;

            if (isStart) {
                p = this.page - 1;
            } else if (isEnd) {
                p = this.page + 1;
            }

            var prefix = '<span ' + (cur ? 'class="current"' : '') + '>';
            var suffix = '</span>';

            if (cur) {

            } else {
                var o = Object.assign({}, window.query);
                o.page = p;

                var q = '?';
                var k = Object.keys(o);
                for (var y = 0; y < k.length; y++) {
                    q += encodeURIComponent(k[y]) + '=' + encodeURIComponent(o[k[y]]);
                    if (y < k.length - 1) q += '&';
                }

                prefix += '<a href="' + q + '" data-pagination data-page="' + p + '">';
                suffix = '</a>' + suffix;
            }


            if (isStart) {
                //<
                x += prefix + '« Previous' + suffix;
                continue;
            }

            if (isEnd) {
                //>
                x += prefix + 'Next »' + suffix;
                continue;
            }

            x += prefix + p + suffix;
        }
        this.pagination.html(x);
    },
    checkLoading: function(e) {},
    onProductsFetched: function(e) {
        AjaxCollection.prototype.onProductsFetched.call(this);
        this.checkLoading(e);
        this.renderTimeout = setTimeout(function() {
            this.redrawPagination();
        }.bind(this), 500);

    },
    onFilterUpdate: function() {
        AjaxCollection.prototype.onFilterUpdate.call(this);
        this.setPage(1);
        this.renderTimeout = setTimeout(function() {
            this.redrawPagination();
        }.bind(this), 500);
    },
    addCustomParams: function(params) {
        if (typeof window.query !== typeof undefined && typeof window.query.top !== typeof undefined) {
            params.top = window.query.top;
        }
        params.perPage = this.perPage;
        return params;
    }
});
OzHairCollectionPage.prototype.constructor = OzHairCollectionPage;

function fnScroll() {
    if (true) return;
    var fnbody = $('.faceted-nav-body');
    if (!fnbody.length) return;
    requestAnimationFrame(fnScroll);

    var fncontainer = $('.faceted-nav-container');
    var nav = $('.navbar-desktop.is-stuck');
    var fixPos = 24;

    var posTop = fncontainer.offset().top;
    var posBottom = posTop + fncontainer.height() - fnbody.height();
    var distanceFromTop = $(this).scrollTop();

    if (nav.length) {
        var h = nav.height();
        fixPos += h;
        distanceFromTop += h;
    }

    if (distanceFromTop >= posTop && distanceFromTop <= posBottom) {
        fnbody.css('top', fixPos + 'px');
        fnbody.addClass('fixed');
        fnbody.removeClass('stopped');
        fnbody.width(fncontainer.width());
    } else if (fnbody.hasClass('fixed') || fnbody.hasClass('stopped')) {
        var posAbs = fnbody.offset().top - posTop;
        posAbs = Math.max(Math.min(posAbs, posBottom - posTop), 0) - 16;
        posAbs = Math.max(0, posAbs);
        fnbody.removeClass('fixed');
        fnbody.addClass('stopped');
        fnbody.css('top', posAbs + 'px');
        fnbody.css('width', '100%');
    }
}

$(document).ready(function() {


    $('.collection-results').each(function() {
        var self = $(this);
        //var handle = self.attr("data-collection-handle");
        handle = self.attr("data-collection-handle");
        //handle = 'hackey-e';

        // var c = new OzHairCollectionPage(
        //   handle,
        //   self.find('.product-list'),
        //   self.find('.collection-pagination'),
        //   self.find('.faceted-nav')
        // );
        // c.fetchInitial();
        // window.collection = c;
    });


    //Product thumbnail add to cart button
    $(document).on('click', '[data-product-addtocart]', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var self = $(this);
        var container = self.closest('.product-thumbnail-container');
        var loader = container.find('.loader-container');
        loader.addClass('visible');

        var succ = function(data) {
            var loader = this.find('.loader-container')
            loader.removeClass('visible');
            var atc = this.find('[data-product-addtocart]');
            atc.addClass('incart');
            Shopify.getCart(function(cart) {
                $(window).trigger('cart-changed', cart);
            }, data);
            window.ajaxCart.open();
        }.bind(container);

        var form = container.find('form');
        var existingQty = 0;
        var id = form.find('[name="id"]').val()
        if (window.cart && window.cart.items) {
            for (var i = 0; i < window.cart.items.length; i++) {
                var c = window.cart.items[i];
                if (!c) continue;
                if (!c.quantity) continue;
                if (c.id != id) continue;
                existingQty = c.quantity;
                break;
            }
        }
        var o = {};
        o[id] = existingQty + 1;
        console.log(id + " : " + existingQty);
        $.ajax({
            url: '/cart/update.js',
            dataType: "json",
            method: "POST",
            data: {
                updates: o
            },
            success: succ,
            error: function(e, a) {
                console.log(e);
                console.log(a);
                window.location.reload();
            }
        });

        e.preventDefault();
    });

    fnScroll();

    /*$(window).on('scroll', function() {
      var fnbody = $('.faceted-nav-body');
      var fncontainer = $('.faceted-nav-container');
      if(!fnbody.length) return;

      var posTop = fncontainer.offset().top;
      var posBottom = posTop + fncontainer.height() - fnbody.height();
      var distanceFromTop = $(this).scrollTop();

      if (distanceFromTop >= posTop && distanceFromTop <= posBottom) {
        fnbody.css('top', '24px');
        fnbody.addClass('fixed');
        fnbody.removeClass('stopped');
      } else if(fnbody.hasClass('fixed')) {
        var posAbs = fnbody.offset().top - posTop;
        posAbs = Math.max(Math.min(posAbs, posBottom-posTop), 0);
        fnbody.removeClass('fixed');
        fnbody.addClass('stopped');
        fnbody.css('top', posAbs + 'px');
      }
    })*/
});

$(document).on('click', '.subnav-expand', function() {
    var self = $(this);
    self.toggleClass('is-toggled');
    self.siblings('[data-subnav-menu]').toggleClass('is-expanded')
});

$(document).on('click', '.collection-list-expand', function() {
    var self = $(this);
    self.toggleClass('is-toggled');
    self.siblings('[data-collection-menu]').toggleClass('is-expanded')
});


function updateFreeGiftBadge() {

    if (typeof SECOMAPP === typeof undefined) return;
    if (typeof SECOMAPP.fgdata === typeof undefined) return;
    if (typeof SECOMAPP.fgdata.products_handle === typeof undefined) return;

    var allgiftrules = SECOMAPP.fgdata.all_gift_rules;

    var catalogProducts = [];
    var cartProducts = [];
    var allPromoOnProduct = false;

    $.each(allgiftrules, function(key, rule) {

        var isFreeGift = (rule.gift_rule_type == 'catalog' && rule.min_numb_prods == 1);

        if (isFreeGift) {
            if (rule.productid_data.length > 0) {
                for (i = 0; i < rule.productid_data.length; i++) {
                    catalogProducts[rule.productid_data[i]] = rule.productid_data[i];
                }
            } else {
                for (i = 0; i < rule.product_id.length; i++) {
                    catalogProducts[rule.product_id[i].product_id] = rule.product_id[i].product_id;
                }
            }
        } else {
            if (rule.productid_data.length > 0) {
                for (i = 0; i < rule.productid_data.length; i++) {
                    cartProducts[rule.productid_data[i]] = rule.productid_data[i];
                }
            } else {
                if (rule.product_id) {
                    for (i = 0; i < rule.product_id.length; i++) {
                        cartProducts[rule.product_id[i].product_id] = rule.product_id[i].product_id;
                    }
                } else { //if rule.productid is empty and rule.product_id doesn't exist, assume rule applies to all products
                    allPromoOnProduct = true;
                }

            }
        }

    });


    $('.product__free-gift-container').each(function(e) {
        var self = $(this);
        var freegift = self.find('.product__free-gift');
        var promo = self.find('.product__free-gift-promo');
        var id = self.attr('data-product-id');
        if (!id) return;

        if (typeof catalogProducts[id] === typeof undefined) {
            freegift.css('display', 'none');
        } else {
            freegift.css('display', 'inline-block');
        }
        if (typeof cartProducts[id] === typeof undefined) {
            promo.css('display', 'none');
        } else {
            promo.css('display', 'inline-block');
        }

        if (allPromoOnProduct) {
            promo.css('display', 'inline-block');
        }

    });

}

function showFreeGift() {

    var promoContainer = $('.free-gift-advert-containers');

    if (promoContainer.length > 0) {

        if (typeof SECOMAPP === typeof undefined) return;
        if (typeof SECOMAPP.fgdata === typeof undefined) return;
        if (typeof SECOMAPP.fgdata.all_gift_rules === typeof undefined) return;

        var allgiftrules = SECOMAPP.fgdata.all_gift_rules;

        $.each(allgiftrules, function(key, rule) {

            var isFreeGift = (rule.gift_rule_type == 'catalog' && rule.min_numb_prods == 1);

            var firstGift = rule.gift_id[0];
            var freeGiftType = (!isFreeGift) ? 'promo' : 'free-gift';
            var freeGiftTitle = (!isFreeGift) ? 'Promo' : 'Free Gift';
            var freeGiftNote = (!isFreeGift) ? '*Free product to be included at cart if above condition is met' : '*Free gift to be included when product is added to cart';
            if (firstGift != undefined)
                var thumbnail = firstGift.thumbnail;
            if (!thumbnail || thumbnail === undefined || thumbnail.length == 0 || !firstGift.thumbnail) {
                return;
            }
            if (thumbnail && firstGift.thumbnail) {
                var cartPromo = '<div class="free-gift-advert-' + freeGiftType + '">' +
                    '<div class="free-gifts-advert-details">' +
                    '<div class="free-gifts-advert-header">' + freeGiftTitle + '</div>' +
                    '<div class="free-gifts-advert-title">' + rule.name + '</div>' +
                    '<div class="free-gifts-advert-subtitle">' + freeGiftNote + '</div>' +
                    '</div>' +
                    '<div class="free-gifts-advert-thumbnail">' +
                    '<img src="' + thumbnail.replace('_thumb', '_150x150') + '" width="86">' +
                    '</div>' +
                    '</div>';
            }
            if (thumbnail) {
                if (rule.productid_data.length > 0) {
                    for (i = 0; i < rule.productid_data.length; i++) {
                        if (rule.productid_data[i] == item.ProductID) {
                            promoContainer.append(cartPromo);
                            break;
                        }
                    }
                } else {
                    if (rule.product_id) {
                        for (i = 0; i < rule.product_id.length; i++) {
                            if (rule.product_id[i].product_id == item.ProductID) {
                                promoContainer.append(cartPromo);
                                break;
                            }
                        }
                    } else { //if rule.productid is empty and rule.product_id doesn't exist, assume rule applies to all products
                        promoContainer.append(cartPromo);
                    }
                }
            } else {
                return true
            }

        });


    }
}

// The SECOMAPP object is not populated on load so the functions need to wait
var loadFreeGiftScripts = setInterval(function() {
    if (typeof SECOMAPP != typeof undefined) {
        if (typeof SECOMAPP.fgdata != typeof undefined) {
            if (typeof SECOMAPP.fgdata.all_gift_rules != typeof undefined) {
                updateFreeGiftBadge();
                showFreeGift();
                clearInterval(loadFreeGiftScripts);
            }
        }
    }
}, 500); // check every 500ms

// =require templates/product.js
function CartLineItem(container, page, data) {
    this.container = container;
    this.page = page;
    this.data = data;

    this.quantitySelectorEl = this.container.find('.product-quantity-selector');
    //this.productRemove = this.container.find('.product-remove-cell');
    this.productRemove = this.container.find('.product-remove-link');

    this.qty = new ProductQuantitySelector(this.quantitySelectorEl);

    this.qty.allowZero(this.onZero.bind(this))
    this.qty.addCallback(this.onChange.bind(this));

    this.productRemove.click(this.remove.bind(this));
}

CartLineItem.prototype = {
    onZero: function() {
        return true;
    },

    onChange: function(e) {
        this.page.load();
        $.ajax({
            url: '/cart/change.js',
            method: 'POST',
            dataType: "json",
            data: {
                quantity: e,
                id: this.data.id
            },
            success: this.refr.bind(this),
            error: this.refr.bind(this)
        });
    },

    error: function() {
        alert("An unexpected error occured!");
        window.location.reload();
    },

    refr: function(d) {
        if (d.items.length == 0) {
            window.location.reload();
            return;
        }
        this.page.setData(d);
    },
    remove: function() {
        this.qty.setAmount(0);
    }
};

//Cart Page
function CartPage(container) {
    this.init(container);
}

CartPage.prototype = {
    init: function(container) {
        this.container = container;
        this.data = window.cart;
        this.cartLoader = this.container.find('.cart-loader');
        this.table = container.find('[data-cart-table]');

        Tablesaw.init();

        this.lineItemsSelector = this.container.find('[data-cart-line-item]');
        this.lineItemElements = [];
        this.lineItems = [];

        this.lineItemsSelector.each(function(i, e) {
            var self = $(e);
            var id = self.attr('data-id');
            this.lineItemElements.push(self);

            var data;
            for (var i = 0; i < this.data.items.length; i++) {
                var x = this.data.items[i];
                if (x.id != id) continue;
                data = x;
                break;
            }

            var item = new CartLineItem(self, this, x);
            this.lineItems.push(item);
        }.bind(this));
    },

    load: function() {
        this.cartLoader.addClass('visible');
    },

    loaded: function() {
        this.cartLoader.removeClass('visible');
    },

    setData: function(d) {
        var _this = this;
        Shopify.getCart(function(cart) {
            _this.data = d;
            $(window).trigger('cart-changed', cart);
            var request = $.ajax({
                url: '/cart',
                data: {
                    "view": "only"
                },
                method: 'GET',
                success: _this.refreshPage.bind(_this),
                error: _this.onError.bind(_this)
            });
        });
    },
    refreshPage: function(d) {
        var x = $(d).insertAfter(this.container);
        this.container.remove();
        this.init(x);
    },
    onError: function() {
        window.location.reload();
    }
}

//Initializer
$(document).ready(function() {
    $('.cart-page-container').each(function() {
        //Does Cart Page have any products?
        var self = $(this);
        window.cartPage = window.cartPage || new CartPage(self);
    });
});

//Mobile Menu
function MobileMenu(menu) {
    this.menu = menu;
    this.container = this.menu.container;
    this.container.find("[data-menu-link]").each(function() {
        var self = $(this);
        self.click(function(e) {
            // checks if the theres anything below the div, else allow click to page
            if (typeof e !== typeof undefined && self.context.firstElementChild) {
                e.preventDefault();
                e.stopPropagation();
            }
            // var submenu = $(
            //   '.submenu[data-menu="' + $(this).attr("data-menu") + '"]'
            // );
            var submenu = self.closest('.menu-item').children('.submenu');
            submenu.find('[data-action="back-menu"]').click(function(e) {
                $(".navbar-mobile .menu-body").css("overflow-y", "auto");
                // $(".rotate").trigger("click");
                var self = $(this).closest(".submenu").first().removeClass("visible");
            });
            // selfLevel2 = self.find("ul");
            // if (self.next().find("li").hasClass('has-submenu') == false) {

            //   self.next().slideToggle();
            // }
            self.toggleClass("rotate");
            submenu.toggleClass("visible");
        });
    });

    this.menu.onMenuClose = function() {
        this.container.find(".menu-list").removeClass("visible");
        $(".navbar-mobile .menu-body").css("overflow-y", "auto");
        $("a").removeClass("rotate");
    }.bind(this.menu);
}
// $(document).ready(function() {
// $(".menu-body").find("[data-menu-link]").on('click', function(){
//   $('.navbar-mobile .menu-body').css('overflow-y', 'hidden');
// });
// $(".item-close a").on('click', function(){
//   $('.navbar-mobile .menu-body .menu-list').css('overflow-y', 'auto');
// });
// });

$(document).ready(function() {
    $(".menu-background").on("click", function() {
        $(".mobile-nav-menu").removeClass("visible");
        $(".menu-list").removeClass("visible");
        $(".navbar-mobile .menu-body").css("overflow-y", "auto");
    });
});

$(document).ready(function() {
    $(".menu-background").on("click", function() {
        $(".mobile-nav-menu").removeClass("visible");
        $(".menu-list").removeClass("visible");
        $(".navbar-mobile .menu-body").css("overflow-y", "auto");
    });
});

$(document).ready(function() {
    var menuObject = window.findMenu('[data-mobile-menu]');
    var menuWrapper = new MobileMenu(menuObject);
});

function update() {
    requestAnimationFrame(update);

    //Top of the window position
    var scrollTop = window.scrollY;

    //Nav sticky
    var nav = $('[data-nav-fixed]');
    var navGhost = $('[data-nav-ghost]');
    var navPosition = $('[data-nav-location]');
    var topBar = $('.top-bar');
    if (!nav.length || !navGhost.length || !navPosition.length) return;

    if (scrollTop >= navPosition.offset().top) {
        if (!nav.hasClass('is-stuck')) {
            nav.addClass('is-stuck');
            if (topBar.length) {
                nav.css('top', topBar.height() + 'px');
            } else {
                nav.css('top', 0);
            }
            navGhost.css('display', 'block');
            navGhost.height(nav.height());
        }
    } else {
        if (nav.hasClass('is-stuck')) {
            nav.css('top', 0);
            nav.removeClass('is-stuck');
            navGhost.css('display', 'none');
            navGhost.height(0);
        }
    }
}
requestAnimationFrame(update);


// Product Add to Cart Sticky
function updateProductAddToCart() {
    requestAnimationFrame(updateProductAddToCart);

    //Top of the window position
    var scrollTop = window.scrollY;
    var addToCartSticky = $('.c-product-page__add-to-cart.is-stuck');
    var pqs = $('.product-information-container .product-quantity-selector');
    var distance = 0;
    if (pqs.length) {
        distance = $('.product-information-container .product-quantity-selector').offset().top;
    }

    var $window = $(window);

    $window.scroll(function() {
        if ($window.scrollTop() >= distance) {
            addToCartSticky.addClass('is-visible');
        } else {
            addToCartSticky.removeClass('is-visible');
        }
    });
}
requestAnimationFrame(updateProductAddToCart);


$(document).ready(function() {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function(evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    var tableSelectors = '.rte table';

    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'rte__table-wrapper',
    });

    // Target iframes to make them responsive
    var iframeSelectors =
        '.rte iframe[src*="youtube.com/embed"],' +
        '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper'
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }
});


var AccordionItem = {
    component: null,
    accordionItem: null,

    init: function(component) {
        this.component = component;
        this.open = false;

        this.initAccordionToggle();
        return this;
    },

    initAccordionToggle: function() {
        var instance = this;
        var accordionItemID = this.component.getAttribute("aria-controls");
        this.accordionItem = document.querySelector('#' + accordionItemID);
        this.component.accordionItem = this.accordionItem;
        this.component.component = this;

        this.accordionItem.accordion = this;

        var initialState = this.accordionItem.getAttribute("aria-expanded");

        if (typeof initialState !== "undefined" && initialState === "false") {
            this.closeAccordionItem();
        }

        this.component.addEventListener(
            "click",
            function(e) {
                e.preventDefault();
                e.stopPropagation();
                if (typeof e.target.component !== "undefined") {
                    var component = e.target.component;
                    component.toggleAccordionItem();
                }
            }
        );
    },

    toggleAccordionItem: function() {
        if (this.open) {
            this.closeAccordionItem();
        } else {
            this.openAccordionItem();
        }
    },

    openAccordionItem: function() {
        this.open = true;
        this.component.classList.remove("closed");
        this.accordionItem.setAttribute("aria-expanded", true);
        $('#short-descriptions').show();
    },

    closeAccordionItem: function() {
        this.open = false;
        this.component.classList.add("closed");
        this.accordionItem.setAttribute("aria-expanded", false);
        $('#full-descriptions').hide();

    }
}

$(".accordion-view-more .view-more").click(function(t) {
    $('#full-descriptions').show();
    $('#short-descriptions').hide();
    $('#description-accordion').removeClass("closed");
    console.log("read more clicked");
    t.preventDefault();

});

$(".accordion-view-more .view-less").click(function(t) {
    $('#full-descriptions').hide();
    $('#short-descriptions').show();
    $('#description-accordion').addClass("closed");
    console.log("read less clicked");
    t.preventDefault();
});

$(document).ready(function() {
    var vanillaAccordions = document.querySelectorAll('.product-mobile-accordion-opener');
    window.accordions = [];

    for (var i = 0; i < vanillaAccordions.length; i++) {
        var accordion = vanillaAccordions[i];

        window.accordions.push(Object.create(AccordionItem).init(accordion));
    }
});

var RelatedProducts = {
    component: null,
    mediaQuery: window.matchMedia("(max-width: 749px)").matches,

    init: function(component) {
        this.component = component;
        console.log(this.mediaQuery);
        this.initSlick();
    },

    initSlick: function() {
        if (this.mediaQuery) {
            $(this.component).slick({
                arrows: true,
                cssEase: 'cubic-bezier(0.23, 1, 0.32, 1)',
                slidesToShow: 2,
                slidesToScroll: 1,
                fade: true
            });
        }
    }
}

$(document).ready(function() {
    var relatedProducts = document.querySelectorAll('.related-products');

    for (var i = 0; i < relatedProducts.length; i++) {
        var relatedProductSection = relatedProducts[i];

        Object.create(RelatedProducts).init(relatedProductSection);
    }
});


// Products Slider
$(document).ready(function() {
    $('.products-slider').slick({
        infinite: true,
        dots: true,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    arrows: true,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    arrows: true,
                    slidesToScroll: 2
                }
            }
        ]
    });
});


// Products Slider
$(document).ready(function() {
    $('.promotion-container').slick({
        infinite: true,
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});

// Related Articles Slider
// $(document).ready(function() {

//   $('.related-article-container .articles').slick({
//     infinite: true,
//     dots: true,
//     arrows: false,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     mobileFirst: true,
//     responsive: [
//       {
//         breakpoint: 767,
//         settings: "unslick"
//       }
//     ]
//   });

//   $(window).on('resize', function() {
//     $('.related-article-container .articles').slick('resize');
//   });

// });

// Header
function Header(container) {
    this.container = container;
    this.topBar = this.container.find('.top-bar');

    // Hide or show close depending on screen height
    this.adjustHeaderPadding();
    $(window).resize(this.adjustHeaderPadding.bind(this));

}
Header.prototype = {
    adjustHeaderPadding: function() {
        this.container.css('padding-top', this.topBar.height());
    },
};
$(document).ready(function() {
    new Header($('.header-banner'));
});

// Desktop Menu Prototype
function DesktopMenu(container) {
    this.container = container;
    this.menuItems = this.container.find(".nav-link");
    this.closeMenu = this.container.find(".meganav");
    this.menuOption = this.container.find(".meganav-menu-option");
    this.menuCollection = this.container.find(".meganav-container.collection");
    this.scrollTimeout = null;
    this.throttle = 50;
    //Event Handlers
    this.menuItems.mouseenter(function() {
        $(".meganav").removeClass("is-open");
        $(this).addClass("is-open");
        $(".border-bar").removeClass("active");
        $(this).find(".border-bar").addClass("active");
        if (!$(this).hasClass('link-shop') && !$(this).hasClass('link-brand')) {
            $(this).find('.meganav-bottom-content').css('display', 'flex');
            $(this)
                .find(".meganav")
                .css(
                    "height",
                    $(this).find(".meganav-container").first().outerHeight() +
                    $(this).find(".meganav-bottom").first().height()
                );
        }
    });
    this.menuItems.mouseleave(function() {
        $(this).removeClass("is-open");
        // $(this).find(".meganav").css("height", "auto");
        $(".meganav-bottom-content").css("display", "none");
        $(this).find(".border-bar").removeClass("active");
        $("#MainContent").css("margin-top", 0);
        $(".meganav-menu-option").removeClass("active");
    });

    this.closeMenu.mouseleave(function() {
        if ($(this).closest(".nav-link").first().hasClass("link-brands")) {
            $(this)
                .closest(".meganav-menu")
                .find(".container-submenu")
                .first()
                .css("display", "block");
        } else {
            $(this).find(".container-submenu").css("display", "none");
            //$(".meganav").css("height", "auto");
        }
        $(this).css("height", "auto");
    });
    this.menuCollection.mouseover(function() {
        $(this).addClass("active");
        $(this).closest('.meganav-collection').css('height', $(this).height() + $(this).closest('.meganav-collection').find('.meganav-bottom').height())
    });
    this.menuOption.mouseover(function() {
        $(".meganav-menu-option").removeClass("active");
        $(this).addClass("active");
        $(".container-submenu").css("display", "none");
        $(".meganav-bottom-content").css("display", "flex");
        var target = $(this).data("target");
        var height;
        $(".container-submenu").each(function() {
            if ($(this).data("target") == target) {
                $(this).css("display", "block");
                height = $(this).outerHeight();
            }
        });
        if (typeof height == "undefined") {
            height = 0;
        }
        $(this)
            .closest(".meganav")
            .css(
                "height",
                $(this).closest(".meganav-container").next().height() +
                $(this).height() +
                height
            );
    });
    this.menuOption.mouseleave(function() {
        var target = $(this).data("target");
        var height;
        $(".container-submenu").each(function() {
            if ($(this).data("target") == target) {
                $(this).css("display", "block");
                height = $(this).outerHeight();
            }
        });
        if (typeof height == "undefined") {
            height = 0;
        }
        if ($(this).closest(".meganav").hasClass("new-style")) {
            $(this)
                .closest(".meganav")
                .css(
                    "height",
                    $(this).closest(".meganav-container").next().height() +
                    $(this).height() +
                    height
                );
        }
    });
    $(".link-brands").mouseenter(function() {
        $(this).find(".container-submenu").css("display", "none");
        $(this).find(".meganav-menu-option").first().addClass("active");
        $(this).find(".container-submenu").first().css("display", "block");
        $(".meganav-bottom-content").css("display", "flex");
        $(this)
            .find(".meganav")
            .css(
                "height",
                $(this).find(".container-submenu").first().outerHeight() +
                $(this).find(".meganav-menu-option").height() +
                $(this).find(".meganav-bottom").first().height()
            );
    });
    $(".container-submenu").mouseover(function() {});
    $(window).on(
        "scroll",
        function() {
            if (!this.scrollTimeout) {
                this.scrollTimeout = setTimeout(
                    function() {
                        //this.closeAllMenus();
                        this.scrollTimeout = null;
                    }.bind(this),
                    this.throttle
                );
            }
        }.bind(this)
    );

    // Menu Menu Desktop Close Button
    this.closeMenu.on("click", this.closeMegaMenu.bind(this));

    // Hide or show close depending on screen height
    this.toggleMenuSize();
    $(window).resize(this.toggleMenuSize.bind(this));
}

DesktopMenu.prototype = {
    closeMegaMenu: function(e) {
        if (typeof e !== typeof undefined) {
            $(e.currentTarget).closest(".nav-link").removeClass("is-open");
        }
    },
    toggleMenuSize: function() {
        var height = $(window).height();
        if (height < 800) {
            this.menuItems.addClass("is-small");
        } else {
            this.menuItems.removeClass("is-small");
        }
    },
    closeAllMenus: function() {
        var openItems = this.container.find(".is-open");
        openItems.each(function() {
            $(this).removeClass("is-open");
        });
    },
};

$(document).ready(function() {
    new DesktopMenu($(".navbar-desktop"));
});




// Article
function Article(container) {
    this.container = container;
    // Adjust top of relared product to offset the fixed header
    this.stickyFeaturedProducts();
    $(window).resize(this.stickyFeaturedProducts.bind(this));
}

Article.prototype = {
    stickyFeaturedProducts: function() {
        this.featuredProducts = this.container.find('.featured-products');
        this.topBar = $('.top-bar');
        this.stickyNav = $('.navbar-desktop');

        // 20px for some padding offset
        var headerOffset = (this.topBar.height() + this.stickyNav.height() + 20);

        if ($(window).height() > (headerOffset + this.featuredProducts.height())) {
            this.featuredProducts.addClass('sticky');
        } else {
            this.featuredProducts.removeClass('sticky');
        }
        this.featuredProducts.css('top', headerOffset);
    }

};

$(document).ready(function() {
    new Article($('.article-page'));
});


// Quizes

function Quiz(container) {

    var instance = this;

    this.container = container;
    this.panels = this.container.find('[data-panel]');
    this.options = this.container.find('.option');
    this.reloadButton = this.container.find('.reloadQuiz');
    this.init();

    // add click event to all options to show the next panel
    this.options.on("click", function(data) {
        instance.recordChoices($(this));
        instance.loadNextPanel($(this).attr('data-next'));
    });

    this.reloadButton.on("click", function() {
        instance.reloadQuiz();
    });

}

Quiz.prototype = {
    init: function() {
        var instance = this;
        instance.currentPanelID = 1;
        instance.recommendationText = '';
        instance.loadFirstPanel();
    },

    loadFirstPanel: function() {
        var instance = this;
        var firstPanel = instance.container.find('[data-panel="' + instance.currentPanelID + '"]');
        firstPanel.show();
    },

    reloadQuiz: function() {
        var instance = this;
        instance.init();
        instance.panels.hide();
        instance.loadFirstPanel();
    },

    recordChoices: function(option) {
        var instance = this;
        var text = '';
        var currentPanel = instance.container.find('[data-panel="' + instance.currentPanelID + '"]');
        if (option.attr('data-text')) {
            text = option.attr('data-text');
        } else {
            text = option.text();
        }
        instance.recommendationText += currentPanel.attr('data-text') + ' <strong>' + text + '</strong>';
    },

    loadNextPanel: function(panelID) {
        var instance = this;
        var panel = instance.container.find('[data-panel="' + panelID + '"]');
        var previousPanel = instance.container.find('[data-panel="' + instance.currentPanelID + '"]');

        previousPanel.fadeOut(function() {
            if (panel.hasClass('result')) {
                panel.find('p.recommendation').html(instance.recommendationText);
            }
            panel.fadeIn();
            instance.currentPanelID = panelID;
        });

    },
}

$(document).ready(function() {
    $(".quiz").each(function() {
        var self = $(this);
        var quiz = new Quiz(self);

        window.quizes = window.quizes || [];
        window.quizes.push(quiz);
    });

});

//Product thumbnail add to cart button
$(document).on('click', '[data-product-addtocart]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var self = $(this);
    var container = self.closest('.product-thumbnail-container');
    var loader = container.find('.loader-container');
    loader.addClass('visible');

    var succ = function(data) {
        var loader = this.find('.loader-container')
        loader.removeClass('visible');
        var atc = this.find('[data-product-addtocart]');
        atc.addClass('incart');
        Shopify.getCart(function(cart) {
            $(window).trigger('cart-changed', cart);
        }, data);
        window.ajaxCart.open();
    }.bind(container);

    var form = container.find('form');
    var existingQty = 0;
    var id = form.find('[name="id"]').val()
    if (window.cart && window.cart.items) {
        for (var i = 0; i < window.cart.items.length; i++) {
            var c = window.cart.items[i];
            if (!c) continue;
            if (!c.quantity) continue;
            if (c.id != id) continue;
            existingQty = c.quantity;
            break;
        }
    }
    var o = {};
    o[id] = existingQty + 1;
    console.log(id + " : " + existingQty);
    $.ajax({
        url: '/cart/update.js',
        dataType: "json",
        method: "POST",
        data: {
            updates: o
        },
        success: succ,
        error: function(e, a) {
            console.log(e);
            console.log(a);
            window.location.reload();
        }
    });

    e.preventDefault();
});
var allPost = new Array();

// get all posts
jQuery('.blog-json').each(function() {
    var json = JSON.parse(jQuery(this).text());
    json.blog = $(this).data("blog");
    json.blogUrl = $(this).data("blog-url");
    allPost.push(json)
        // $.merge(allPost, json);
});

// sort post by date
function sortbyDate(post) {
    post.sort(function(a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.updated_at) - new Date(a.updated_at);
    })
}

sortbyDate(allPost);
getPost(0, allPost);

function getPost(index, collection) {
    jQuery('.blog-landing-wrapper .blog-landing-content').html('');
    jQuery('.blog-landing-wrapper .blog-landing-content').append('<div class="loader"></div>');
    for (var i = index; i < collection.length; i++) {
        var post = collection[i];
        var blogId = post.blog_id;
        var blog = post.blog;
        var blogUrl = post.blogUrl;
        var postUrl = post.blogUrl;
        var blogTitle = jQuery('.blog-json[data-blog-id="' + blogId + '"]').data('blogTitle');
        var postImage = '';
        var post_sumary = '';
        var regex = /(<([^>]+)>)/ig;
        var post_content = post.body_html.replace(regex, "");
        var blogTags = post.tags;
        var include = blogTags.includes("Video")

        if (post.image) {
            postImage = post.image.src;
        } else {
            postImage = "//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_1400x.gif"
        }
        if (i > 0 & i < 9) {
            var postHtml = '<div class="article-item-container col-2">';
            postHtml += '<div class="article-item_image-container">';
            postHtml += '<a href="' + postUrl + '">';
            postHtml += '<img class="article-item_image lazyload image--blur-up" src="' + postImage + '" >';
            postHtml += '</a>';
            postHtml += '</div>';
            postHtml += '<div class="article-item-details">';
            postHtml += '<div class="article-item-title">';
            postHtml += '<p>' + post.title + '</p>';
            postHtml += '</div>';
            postHtml += '<div>';
            if (include == true) {
                postHtml += '<a href="' + postUrl + '">Watch Video</a>'
            } else {
                postHtml += '<a href="' + postUrl + '">Read more</a>'
            }

            postHtml += '</div>';
            postHtml += '</div>';
        } else if (i > 9) {
            var postHtml = '<div class="article-item-container col-2 hidden">';
            postHtml += '<div class="article-item_image-container">';
            postHtml += '<a href="' + postUrl + '">';
            postHtml += '<img class="article-item_image lazyload image--blur-up" src="' + postImage + '" >';
            postHtml += '</a>';
            postHtml += '</div>';
            postHtml += '<div class="article-item-details">';
            postHtml += '<div class="article-item-title">';
            postHtml += '<p>' + post.title + '</p>';
            postHtml += '</div>';
            postHtml += '<div>';
            if (include == true) {
                postHtml += '<a href="' + postUrl + '">Watch Video</a>'
            } else {
                postHtml += '<a href="' + postUrl + '">Read more</a>'
            }
            postHtml += '</div>';
            postHtml += '</div>';
        } else {
            var postHtml = '<div class="article-item-container col-2">';
            postHtml += '<div class="article-item_image-container">';
            postHtml += '<a href="' + postUrl + '">';
            postHtml += '<img class="article-item_image lazyload image--blur-up" src="' + postImage + '" >';
            postHtml += '</a>';
            postHtml += '</div>';
            postHtml += '<div class="article-item-details">';
            postHtml += '<div class="article-item-title">';
            postHtml += '<p>' + post.title + '</p>';
            postHtml += '</div>';
            postHtml += '<div>';
            postHtml += '<a href="' + postUrl + '">Read more</a>'
            postHtml += '</div>';
            postHtml += '</div>';
        }
        if (i < 4) {
            var postMenu = '<div class="blog">';
            postMenu += '<div class="image">';
            postMenu += '<a href="' + postUrl + '">';
            postMenu += '<img src="' + postImage + '" alt="">';
            postMenu += '</a>';
            postMenu += '</div>';
            postMenu += '<div class="blog-details">';
            postMenu += '<a class="tags" href="' + blogUrl + '">' + blog + '</a>';
            postMenu += '<p class="title">' + post.title + '</p>';
            postMenu += '<a class="read-more" href="' + postUrl + '">Read more</a>'
            postMenu += '</div>';
            postMenu += '</div>';
        } else {
            postMenu = "";
        }
        if (i < 2) {
            var postMenuMobile = '<div class="blog">';
            postMenuMobile += '<div class="image">';
            postMenuMobile += '<a href="' + postUrl + '">';
            postMenuMobile += '<img src="' + postImage + '" alt="">';
            postMenuMobile += '</a>';
            postMenuMobile += '</div>';
            postMenuMobile += '<div class="blog-details">';
            postMenuMobile += '<p class="title">' + post.title + '</p>';
            postMenuMobile += '<a class="read-more" href="' + postUrl + '">Read more</a>'
            postMenuMobile += '</div>';
            postMenuMobile += '</div>';
        } else {
            postMenuMobile = "";
        }
        jQuery('.meganav-menu .blog-container').append(postMenu);
        jQuery('.mobile-nav-menu .link-blog .blog-container').prepend(postMenuMobile);
        jQuery('.blog-landing-wrapper .blog-landing-content').append(postHtml);
    }
}
$(".meganav.brands .meganav-submenu-sub-option").each(function() {
    var length_a = $(this).find("a").length;
    if (length_a > 11) {
        $(this).addClass("two-collumn");
    }
});